(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════
     DATA — Populated dynamically from DB via API
     ═══════════════════════════════════════════════════════ */

  var PHONE_GROUPS = [];
  var CASE_TYPES = [];
  var CASE_COLORS = {};
  var FONTS = [];
  var TEXT_COLORS = [];
  var ORIGINAL_TEXT_COLORS = [];
  var LAYOUT_PRESETS = [
    { id: 'center',   name: 'Center',   yRatio: 0.5,  align: 'center' },
    { id: 'bottom',   name: 'Bottom',   yRatio: 0.82, align: 'center' },
    { id: 'top',      name: 'Top',      yRatio: 0.18, align: 'center' },
    { id: 'diagonal', name: 'Diagonal', yRatio: 0.5,  align: 'center', rotation: -25 }
  ];

  /* ── Collage layout definitions ────────────────────────── */
  var COLLAGE_LAYOUTS = [
    { id:'1x1', slots:1, cols:1, rows:1,
      cells:[{x:0,y:0,w:1,h:1}] },
    { id:'1x2', slots:2, cols:1, rows:2,
      cells:[{x:0,y:0,w:1,h:0.5},{x:0,y:0.5,w:1,h:0.5}] },
    { id:'2x1', slots:2, cols:2, rows:1,
      cells:[{x:0,y:0,w:0.5,h:1},{x:0.5,y:0,w:0.5,h:1}] },
    { id:'1x3', slots:3, cols:1, rows:3,
      cells:[{x:0,y:0,w:1,h:0.333},{x:0,y:0.333,w:1,h:0.333},{x:0,y:0.667,w:1,h:0.334}] },
    { id:'2x2', slots:4, cols:2, rows:2,
      cells:[{x:0,y:0,w:0.5,h:0.5},{x:0.5,y:0,w:0.5,h:0.5},{x:0,y:0.5,w:0.5,h:0.5},{x:0.5,y:0.5,w:0.5,h:0.5}] },
    { id:'2x3', slots:6, cols:2, rows:3,
      cells:[{x:0,y:0,w:0.5,h:0.333},{x:0.5,y:0,w:0.5,h:0.333},{x:0,y:0.333,w:0.5,h:0.333},{x:0.5,y:0.333,w:0.5,h:0.333},{x:0,y:0.667,w:0.5,h:0.334},{x:0.5,y:0.667,w:0.5,h:0.334}] },
    { id:'3x3', slots:9, cols:3, rows:3,
      cells:[{x:0,y:0,w:0.333,h:0.333},{x:0.333,y:0,w:0.333,h:0.333},{x:0.667,y:0,w:0.334,h:0.333},{x:0,y:0.333,w:0.333,h:0.333},{x:0.333,y:0.333,w:0.333,h:0.333},{x:0.667,y:0.333,w:0.334,h:0.333},{x:0,y:0.667,w:0.333,h:0.334},{x:0.333,y:0.667,w:0.333,h:0.334},{x:0.667,y:0.667,w:0.334,h:0.334}] }
  ];

  var collageImageCache = {};

  var DB_OPTIONS = {};
  // Disponibilità PER COVER TYPE (id tipo -> { slug_modello: [{slug_color, available,...}] }).
  // DB_OPTIONS da sola appartiene al tipo del config iniziale: filtrarci gli altri
  // tipi nascondeva colori legittimi (es. "clear" sulle Clear MagSafe).
  var DB_OPTIONS_BY_TYPE = {};

  /* ── Dedicated Shopify product "Custom Studio Phone Case" ──
     1 variante per tipo cover; matchiamo per SKU = product_model
     (es. Tough_Phone_Case). Caricato a runtime da /products/<handle>.js */
  var STUDIO_PRODUCT_HANDLE = 'custom-studio-phone-case';
  var STUDIO_VARIANTS = [];          // array di {id, sku, available}
  var STUDIO_VARIANT_BY_SKU = {};    // sku → variant id
  // alias product_model che possono variare tra API e fallback
  var STUDIO_SKU_ALIASES = {
    'Clear_Case_with_MagSafe': 'Clear_MagSafe_Phone_Case',
    'Clear_MagSafe_Phone_Case': 'Clear_MagSafe_Phone_Case'
  };

  var COLOR_HEX_MAP = {
    'black':'#1a1a1a','rose':'#e8b4b8','yellow':'#f0ec74','lilac':'#c8a2c8',
    'red':'#da291c','navy':'#1b2a4a','brown':'#8b6914','green':'#2d5a27',
    'fuchsia':'#f04e98','lightgreen':'#90ee90','orange':'#eb7930','beige':'#f5f5dc',
    'aqua':'#7ec8e3','croco-pink':'#f0b4c8','croco-black':'#2a2a2a',
    'croco-beige':'#e8dcc8','croco-white':'#f5f0e8','white':'#f5f5f0',
    'gold':'#d4a843','clear':'#e8e8e8','pink':'#e8b4b8','bordeaux':'#9d2235',
    'clear-black':'#333333','purple':'#ad96dc','blue':'#4169e1',
    'kelly-green':'#4cbb17','blank':'#f0f0f0'
  };

  function slugToLabel(slug) {
    return slug.replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function groupSizesIntoPhoneGroups(sizes) {
    var groups = {};
    var order = ['17','16','15','14','13','12','11','X','XS','XR','SE','8','7'];

    sizes.forEach(function (slug) {
      var stripped = slug.replace(/^iphone_/i, '');
      var genMatch = stripped.match(/^(\d+|x|xs|xr|se)/i);
      var gen = genMatch ? genMatch[1].toUpperCase() : stripped;

      var displayName = slug
        .replace(/^iphone_/i, '')
        .replace(/_/g, ' ')
        .replace(/\//g, '/')
        .replace(/\b\w/g, function (c) { return c.toUpperCase(); });

      if (!groups[gen]) groups[gen] = [];
      groups[gen].push({
        id: slug,
        name: displayName,
        apiSize: slug.replace(/^iphone_/i, 'iPhone_')
      });
    });

    var result = [];
    order.forEach(function (g) {
      if (groups[g] && groups[g].length) {
        result.push({ label: 'iPhone ' + g, models: groups[g] });
      }
    });
    Object.keys(groups).forEach(function (g) {
      if (order.indexOf(g) === -1 && groups[g].length) {
        result.push({ label: 'iPhone ' + g, models: groups[g] });
      }
    });
    return result;
  }

  var PHONE_DIMS = {
    default: { w: 710, h: 1500, r: 46 }
  };

  var BASE_W = 400;
  var BASE_H = 820;
  var CASE_EDGE = 18;
  var PRINT_PADDING = 10;

  /* ═══════════════════════════════════════════════════════
     API v1.1 — Cover image rendering
     ═══════════════════════════════════════════════════════ */

  var API_KEY = '67249482206019324505';

  /**
   * Da Chrome 142+ le richieste verso indirizzi di rete privata (localhost, 127/8, 10/8, 172.16/12,
   * 192.168/16, *.local) fanno comparire il prompt "Local Network Access" ("vorrebbe accedere ad
   * altri servizi e app su questo dispositivo"). In produzione non deve mai apparire: filtriamo
   * qualsiasi URL configurato accidentalmente verso un host privato e cadiamo sul default pubblico.
   */
  function isPrivateOrLocalHost(host) {
    if (!host) return false;
    var h = String(host).toLowerCase();
    if (h === 'localhost' || h.endsWith('.local') || h.endsWith('.localhost')) return true;
    if (h === '127.0.0.1' || /^127\./.test(h)) return true;
    if (h === '0.0.0.0') return true;
    if (/^10\./.test(h)) return true;
    if (/^192\.168\./.test(h)) return true;
    if (/^172\.(1[6-9]|2\d|3[01])\./.test(h)) return true;
    if (/^169\.254\./.test(h)) return true;
    return false;
  }

  function isCurrentPagePublic() {
    if (typeof window === 'undefined' || !window.location) return false;
    var h = window.location.hostname || '';
    if (window.location.protocol === 'file:') return false;
    return !isPrivateOrLocalHost(h);
  }

  function safePublicUrl(raw) {
    if (!raw) return '';
    var s = String(raw).trim();
    if (!s) return '';
    if (!isCurrentPagePublic()) return s;
    try {
      var u = new URL(s, window.location.href);
      if (isPrivateOrLocalHost(u.hostname)) return '';
      if (u.protocol !== 'https:' && u.protocol !== 'http:') return '';
      return s;
    } catch (e) {
      return '';
    }
  }

  /** Base v1.1: imposta `window.CLS_API_BASE` (es. script inline prima di questo file) per produzione. */
  function getApiBase() {
    if (typeof window !== 'undefined' && window.CLS_API_BASE) {
      var safe = safePublicUrl(window.CLS_API_BASE);
      if (safe) return safe.replace(/\/?$/, '/');
    }
    // Fallback locale per sviluppo/demo; in produzione imposta CLS_API_BASE via metafield Shopify.
    if (typeof window !== 'undefined' && window.location &&
        (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
      return 'http://localhost:8888/v1.1/';
    }
    return 'https://api.ntngrp.com/v1.1/';
  }

  var API_BASE = getApiBase();
  function getAssetBase() {
    if (typeof window !== 'undefined' && window.CLS_ASSET_BASE) {
      var safe = safePublicUrl(window.CLS_ASSET_BASE);
      if (safe) return safe.replace(/\/?$/, '/');
    }
    return getApiBase();
  }
  var API_STUDIO_BASE = API_BASE + 'coverlab_studio_base.php?keyap=' + API_KEY;
  function getRemoveBgUrl() {
    if (typeof window !== 'undefined' && window.CLS_REMOVEBG_URL) {
      var safe = safePublicUrl(window.CLS_REMOVEBG_URL);
      if (safe) return safe;
    }
    if (typeof window !== 'undefined' && window.location &&
        (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
      return 'http://localhost:8888/v1.1/coverlab_removebg_proxy.php';
    }
    return 'https://api.ntngrp.com/v1.1/coverlab_removebg_proxy.php';
  }
  var API_REMOVEBG = getRemoveBgUrl();

  function refreshApiRootsFromDom() {
    API_BASE = getApiBase();
    API_STUDIO_BASE = API_BASE + 'coverlab_studio_base.php?keyap=' + API_KEY;
    API_REMOVEBG = getRemoveBgUrl();
    FONT_BASE_URL = API_STUDIO_BASE.replace(/coverlab_studio_base\.php.*/, '');
  }

  function getApiSize(modelId) {
    if (!modelId) return 'iPhone_17_Pro';
    if (modelId.indexOf('iPhone_') === 0 || modelId.indexOf('iphone_') === 0) {
      return modelId.replace(/^iphone_/i, 'iPhone_');
    }
    return 'iPhone_17_Pro';
  }

  function getApiProductModel() {
    if (!CASE_TYPES.length) return 'Vegan_Leather_Phone_Case';
    // Match per id reale (id_main) oppure per product_model (deep-link PDP).
    var ct = CASE_TYPES.find(function (t) { return String(t.id) === String(state.caseType); }) ||
             CASE_TYPES.find(function (t) { return t.product_model === state.caseType; });
    if (ct && ct.product_model) return ct.product_model;
    return CASE_TYPES[0].product_model || 'Vegan_Leather_Phone_Case';
  }

  var CORNER_RADIUS_MAP = {
    'Tough_Phone_Case': 90,
    'Vegan_Leather_Phone_Case': 82,
    'Vegan_Leather_Phone_Case_with_Loop': 82,
    'Clear_Case_with_MagSafe': 78
  };

  function getCoverCornerRadius() {
    var model = getApiProductModel();
    return CORNER_RADIUS_MAP[model] || 44;
  }

  /** Percorsi tipo `img_base/207.png` → assoluti rispetto a API_BASE (PNG grafica sopra la custodia). */
  function resolveStudioGraphicUrl(url) {
    if (!url || typeof url !== 'string') return url;
    var trimmed = url.trim();
    if (!trimmed) return trimmed;
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    if (/^\/\//.test(trimmed)) return trimmed;
    var base = getAssetBase().replace(/\/?$/, '/');
    if (trimmed.charAt(0) === '/') {
      try {
        var u = new URL(getAssetBase());
        return u.origin + trimmed;
      } catch (e) {
        return base + trimmed.replace(/^\//, '');
      }
    }
    return base + trimmed.replace(/^\//, '');
  }

  function destroyProductGraphicNodes() {
    printLayer.find('.baseDesign').forEach(function (n) { n.destroy(); });
    bgLayer.find('.productGraphicClip').forEach(function (n) { n.destroy(); });
  }

  /* ═══════════════════════════════════════════════════════
     STATE
     ═══════════════════════════════════════════════════════ */

  var state = {
    mode: 'initials',
    collageLayout: '2x2',
    collagePhotos: {},
    phoneModel: '',
    caseType: '',
    caseColor: 'black',
    currentStep: '0',
    totalSteps: 7,
    selectedFont: '',
    selectedFontId: '',
    selectedTextColor: '#000000',
    selectedTextColorSlug: '',
    selectedTextSize: 48,
    selectedLayoutId: '1',
    customText: '',
    undoStack: [],
    stickerEffect: 'none',
    baseDesignUrl: null,
    productId: null,
    mainProductId: null,
    apiRendering: false,
    useApiBase: false,
    awaitingApiBase: true,
    maxChars: 12,
    textTransform: 'none',
    coverTypes: [],
    availableSizes: [],
    toughBases: [],
    selectedBaseDesign: null,
    requestedCaseType: null,
    _baseLoaded: false
  };

  /* ═══════════════════════════════════════════════════════
     KONVA OBJECTS
     ═══════════════════════════════════════════════════════ */

  var stage, bgLayer, printLayer, overlayLayer, uiLayer, transformer;
  var phoneGroup, caseShape, printGroup, printClip;
  var currentScale = 1;

  /* ═══════════════════════════════════════════════════════
     INIT
     ═══════════════════════════════════════════════════════ */

  function init() {
    refreshApiRootsFromDom();
    parseQueryParams();
    initCanvas();
    buildSidebar();
    bindAccordion();
    bindModeSwitch();
    bindBottomBar();
    bindMobileTabs();
    bindTextTools();
    bindUploadTools();
    bindEffects();
    bindCartButton();
    loadStudioVariants();
    openStep(1); // primo step = Phone Model (data-step="1")
    showApiLoadingIndicator(true);
    drawPhone();
    enableAddToCart();
    window.addEventListener('resize', debounce(onResize, 150));
    document.getElementById('cls-rotate-hint').style.display = 'flex';

    requestBaseImage();
    clearTimeout(_caseTypesFailSafeTimer);
    _caseTypesFailSafeTimer = setTimeout(function () {
      if (!CASE_TYPES.length) ensureFallbackCaseTypes(true);
    }, 5000);
  }

  function parseQueryParams() {
    var params = new URLSearchParams(window.location.search);
    var bd = params.get('base_design') || params.get('design') || params.get('graphic');
    if (bd) {
      try {
        state.baseDesignUrl = decodeURIComponent(bd);
      } catch (e) {
        state.baseDesignUrl = bd;
      }
    } else {
      var designId = params.get('design_id') || params.get('cmt_design') || params.get('codice_design');
      if (designId) {
        var safe = String(designId).replace(/[^\w.-]/g, '');
        if (safe) state.baseDesignUrl = 'img_base/' + safe + '.png';
      }
    }
    if (params.get('model')) state.phoneModel = params.get('model');
    if (params.get('mode')) state.mode = params.get('mode');
    if (params.get('product_id')) state.productId = params.get('product_id');
    if (params.get('id_p')) state.productId = params.get('id_p');
    if (params.get('id_m_p')) state.mainProductId = params.get('id_m_p');
    if (params.get('variant')) state.variantId = params.get('variant');
    if (params.get('color')) state.caseColor = params.get('color');
    if (params.get('case_type')) {
      state.caseType = params.get('case_type');
      // Il deep-link dalla PDP passa il product_model (es. "Tough_Phone_Case"),
      // ma i CASE_TYPES caricati dall'API hanno id = id_main (numerico). Teniamo il
      // valore richiesto per risolverlo all'id reale dopo applyDbConfig (vedi
      // resolveRequestedCaseType) ed evitare che venga resettato al primo case type.
      state.requestedCaseType = params.get('case_type');
    }
    if (params.get('tough_base')) state.selectedBaseDesign = params.get('tough_base');
  }

  /* Risolve il case_type richiesto via deep-link (id_main o product_model) all'id
     reale presente in CASE_TYPES. Idempotente: una volta risolto azzera il flag. */
  function resolveRequestedCaseType() {
    if (!state.requestedCaseType || !CASE_TYPES.length) return;
    var raw = String(state.requestedCaseType);
    var match = CASE_TYPES.find(function (t) { return String(t.id) === raw; }) ||
                CASE_TYPES.find(function (t) { return t.product_model === raw; });
    if (match) {
      state.caseType = match.id;
      state.requestedCaseType = null;
    }
  }

  /* Il deep-link PDP passa il modello come "iPhone_14", ma gli id dei bottoni
     (da cfg.sizes) sono minuscoli "iphone_14": allineiamo state.phoneModel all'id
     REALE con match case-insensitive, così il bottone risulta selezionato. */
  function resolveRequestedModel() {
    if (!state.phoneModel || !PHONE_GROUPS.length) return;
    var want = String(state.phoneModel).toLowerCase().replace(/\s+/g, '_');
    for (var i = 0; i < PHONE_GROUPS.length; i++) {
      var ms = PHONE_GROUPS[i].models;
      for (var j = 0; j < ms.length; j++) {
        if (String(ms[j].id).toLowerCase() === want) { state.phoneModel = ms[j].id; return; }
      }
    }
  }

  /* ═══════════════════════════════════════════════════════
     API v1.1 — Fetch base cover image (no text/design)
     ═══════════════════════════════════════════════════════ */

  var _baseTimer = null;
  var _caseTypesFailSafeTimer = null;

  function ensureFallbackCaseTypes(force) {
    if (!force && CASE_TYPES.length) return false;

    CASE_TYPES = [
      { id: 'Vegan_Leather_Phone_Case', name: 'Leather Case', price: '', desc: 'Default', url: '', product_model: 'Vegan_Leather_Phone_Case', shopifyId: null, id_main: null, slug_cat: '', sizes: [] },
      { id: 'Tough_Phone_Case', name: 'Tough Case', price: '', desc: 'Default', url: '', product_model: 'Tough_Phone_Case', shopifyId: null, id_main: null, slug_cat: '', sizes: [] },
      { id: 'Clear_Case_with_MagSafe', name: 'Clear MagSafe', price: '', desc: 'Default', url: '', product_model: 'Clear_Case_with_MagSafe', shopifyId: null, id_main: null, slug_cat: '', sizes: [] }
    ];

    var black = { id: 'black', hex: COLOR_HEX_MAP.black || '#1a1a1a', name: 'Black' };
    var rose = { id: 'rose', hex: COLOR_HEX_MAP.rose || '#e8b4b8', name: 'Rose' };
    var clear = { id: 'clear', hex: COLOR_HEX_MAP.clear || '#e8e8e8', name: 'Clear' };
    CASE_COLORS['Vegan_Leather_Phone_Case'] = [black, rose];
    CASE_COLORS['Tough_Phone_Case'] = [black, rose];
    CASE_COLORS['Clear_Case_with_MagSafe'] = [clear, black];

    if (!state.caseType || !CASE_TYPES.find(function (t) { return t.id === state.caseType; })) {
      state.caseType = CASE_TYPES[0].id;
    }
    var activeColors = CASE_COLORS[state.caseType] || [];
    if (activeColors.length && !activeColors.find(function (c) { return c.id === state.caseColor; })) {
      state.caseColor = activeColors[0].id;
    }

    buildCaseTypes();
    buildColorSwatches();
    updateHeaderInfo();
    return true;
  }

  function cloneTextPalette(list) {
    return (list || []).map(function (c) {
      return { hex: c.hex, name: c.name, slug: c.slug };
    });
  }

  function normalizeHexColor(hex) {
    if (!hex) return '#000000';
    var h = String(hex).trim();
    if (h.charAt(0) !== '#') h = '#' + h;
    if (h.length === 4) {
      h = '#' + h.charAt(1) + h.charAt(1) + h.charAt(2) + h.charAt(2) + h.charAt(3) + h.charAt(3);
    }
    return /^#[0-9a-fA-F]{6}$/.test(h) ? h.toLowerCase() : '#000000';
  }

  function rgbToHex(r, g, b) {
    function p(v) { return Math.max(0, Math.min(255, v | 0)).toString(16).padStart(2, '0'); }
    return '#' + p(r) + p(g) + p(b);
  }

  function colorDistanceSq(a, b) {
    var dr = a.r - b.r;
    var dg = a.g - b.g;
    var db = a.b - b.b;
    return dr * dr + dg * dg + db * db;
  }

  function extractTextPaletteFromImage(src, done) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var w = img.naturalWidth || img.width;
        var h = img.naturalHeight || img.height;
        if (!w || !h) return done([]);
        var targetW = 220;
        var scale = Math.min(1, targetW / w);
        var cw = Math.max(1, Math.round(w * scale));
        var ch = Math.max(1, Math.round(h * scale));
        var cv = document.createElement('canvas');
        cv.width = cw;
        cv.height = ch;
        var ctx = cv.getContext('2d', { willReadFrequently: true });
        if (!ctx) return done([]);
        ctx.drawImage(img, 0, 0, cw, ch);
        var data = ctx.getImageData(0, 0, cw, ch).data;
        var buckets = {};
        var step = 4 * 4; // campionamento 1px ogni 4
        for (var i = 0; i < data.length; i += step) {
          var a = data[i + 3];
          if (a < 80) continue;
          var r = data[i], g = data[i + 1], b = data[i + 2];
          // Escludi quasi-bianchi e quasi-neri estremi come colori principali
          if ((r > 245 && g > 245 && b > 245) || (r < 10 && g < 10 && b < 10)) continue;
          var qR = Math.round(r / 24) * 24;
          var qG = Math.round(g / 24) * 24;
          var qB = Math.round(b / 24) * 24;
          var k = qR + ',' + qG + ',' + qB;
          if (!buckets[k]) buckets[k] = { r: qR, g: qG, b: qB, n: 0 };
          buckets[k].n++;
        }
        var arr = Object.keys(buckets).map(function (k) { return buckets[k]; })
          .sort(function (x, y) { return y.n - x.n; });
        var picked = [];
        for (var j = 0; j < arr.length && picked.length < 6; j++) {
          var c = arr[j];
          var tooClose = picked.some(function (p) { return colorDistanceSq(p, c) < 1600; });
          if (tooClose) continue;
          picked.push(c);
        }
        var palette = picked.map(function (c, idx) {
          return {
            hex: rgbToHex(c.r, c.g, c.b),
            name: 'Auto ' + (idx + 1),
            slug: 'auto-' + (idx + 1)
          };
        });
        // fallback contrast colors
        palette.push({ hex: '#111111', name: 'Auto Dark', slug: 'auto-dark' });
        palette.push({ hex: '#ffffff', name: 'Auto Light', slug: 'auto-light' });
        done(palette);
      } catch (e) {
        done([]);
      }
    };
    img.onerror = function () { done([]); };
    img.src = src;
  }

  function applyTextPalette(list, options) {
    options = options || {};
    if (!list || !list.length) return;
    var clean = [];
    var seen = {};
    list.forEach(function (c) {
      var hex = normalizeHexColor(c.hex);
      if (seen[hex]) return;
      seen[hex] = true;
      clean.push({
        hex: hex,
        name: c.name || hex,
        slug: c.slug || (c.name ? String(c.name).toLowerCase().replace(/\s+/g, '-') : hex.replace('#', ''))
      });
    });
    if (!clean.length) return;
    TEXT_COLORS.length = 0;
    clean.forEach(function (c) { TEXT_COLORS.push(c); });
    state.selectedTextColor = clean[0].hex;
    state.selectedTextColorSlug = clean[0].slug;
    buildTextColors();
    if (options.applyToSelectedText) {
      updateSelectedText({ fill: clean[0].hex });
    }
  }

  function applyAutoTextPaletteForToughBase(codiceDesign) {
    if (!isToughCase() || !codiceDesign) return;
    var base = (state.toughBases || []).find(function (b) { return String(b.codice_design) === String(codiceDesign); });
    if (!base || !base.thumb) return;
    extractTextPaletteFromImage(base.thumb, function (palette) {
      if (!isToughCase() || String(state.selectedBaseDesign) !== String(codiceDesign)) return;
      if (palette && palette.length) {
        applyTextPalette(palette, { applyToSelectedText: false });
      }
    });
  }
  function requestBaseImage() {
    clearTimeout(_baseTimer);
    _baseTimer = setTimeout(fetchBaseImage, 200);
  }

  /* Ri-renderizza la base preservando la grafica scelta: su Tough con un base
     design selezionato (es. Blur) usa render_tough_base con il codice_design per
     la nuova size/modello, invece della base Tough generica (blank). Da usare in
     tutti gli handler di cambio modello / case type / colore / base. */
  function refreshBasePreservingDesign() {
    if (isToughCase() && state.selectedBaseDesign) {
      selectToughBase(state.selectedBaseDesign);
    } else {
      requestBaseImage();
    }
  }

  /** Il mock rettangolare (cover finta) serve solo in fallback: se la base arriva dall'API, non ridisegno. */
  function drawPhoneUnlessUsingApi() {
    if (!state.useApiBase) drawPhone();
  }

  var _configLoaded = false;

  function finishApiBaseLoadingWithPlaceholder() {
    state.awaitingApiBase = false;
    showApiLoadingIndicator(false);
    state.useApiBase = false;
    overlayLayer.destroyChildren();
    _cameraOverlayNode = null;
    _lastCameraMeta = null;
    if (!CASE_TYPES.length) ensureFallbackCaseTypes(true);
    drawPhone();
  }

  function getCameraApiUrl() {
    var apiSize = getApiSize(state.phoneModel);
    return API_STUDIO_BASE +
      '&action=render_camera' +
      '&cmt_size=' + encodeURIComponent(apiSize) +
      '&product_model=' + encodeURIComponent(getApiProductModel()) +
      '&product_color=' + encodeURIComponent(state.caseColor);
  }

  function fetchBaseImage() {
    if (state.apiRendering) return;
    state.apiRendering = true;
    showApiLoadingIndicator(true);

    var params = {
      cmt_size:      getApiSize(state.phoneModel),
      product_model: getApiProductModel(),
      product_color: state.caseColor
    };

    if (!_configLoaded) {
      params.action = 'both';
      if (state.productId) params.id_p = state.productId;
      if (state.mainProductId) params.id_m_p = state.mainProductId;
    } else {
      params.action = 'render';
    }

    var qs = Object.keys(params).map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
    }).join('&');
    var mainUrl = API_STUDIO_BASE + '&' + qs;

    fetch(mainUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        state.apiRendering = false;
        if (!data || !data.success) {
          finishApiBaseLoadingWithPlaceholder();
          return;
        }
        if (data.config && !_configLoaded) {
          applyDbConfig(data.config);
          _configLoaded = true;
        }
        if (!data.image) {
          finishApiBaseLoadingWithPlaceholder();
          return;
        }
        return fetch(getCameraApiUrl())
          .then(function (r) { return r.json(); })
          .catch(function () { return {}; })
          .then(function (dataCam) {
            var cam = (dataCam && dataCam.camera && dataCam.camera.image) ? dataCam.camera : null;
            displayBaseImage(data.image, cam);
          });
      })
      .catch(function (err) {
        state.apiRendering = false;
        finishApiBaseLoadingWithPlaceholder();
        console.warn('studio_base error:', err);
      });
  }

  function applyDbConfig(cfg) {
    clearTimeout(_caseTypesFailSafeTimer);
    /* Phone models (sizes) */
    if (cfg.sizes && cfg.sizes.length) {
      PHONE_GROUPS = groupSizesIntoPhoneGroups(cfg.sizes);
      resolveRequestedModel(); // allinea il modello del deep-link all'id reale (case-insensitive)
      if (!state.phoneModel && PHONE_GROUPS.length && PHONE_GROUPS[0].models.length) {
        state.phoneModel = PHONE_GROUPS[0].models[0].id;
      }
      buildModelGroups();
    }

    /* Options (availability per size+color) */
    if (cfg.options) {
      DB_OPTIONS = cfg.options;
    }

    /* Case colors */
    if (cfg.colors && cfg.colors.length) {
      var colorList = cfg.colors.map(function (c) {
        var hex = c.codice_colore || COLOR_HEX_MAP[c.slug_colore] || '#999';
        return { id: c.slug_colore, hex: hex, name: c.colore };
      });
      CASE_COLORS[state.caseType] = colorList;
      if (!state.caseColor || !colorList.find(function (c) { return c.id === state.caseColor; })) {
        state.caseColor = colorList[0].id;
      }
      buildColorSwatches();
    }

    /* Cover types */
    if (cfg.cover_types && cfg.cover_types.length) {
      CASE_TYPES = cfg.cover_types.map(function (ct) {
        var typeId = ct.id_main || ct.id_product || ct.product_model || ct.product_type;
        var ctId = String(typeId);

        if (ct.colors && ct.colors.length) {
          CASE_COLORS[ctId] = ct.colors.map(function (c) {
            var hex = c.codice_colore || COLOR_HEX_MAP[c.slug_colore] || '#999';
            return { id: c.slug_colore, hex: hex, name: c.colore };
          });
        }

        if (ct.options) {
          DB_OPTIONS_BY_TYPE[ctId] = ct.options;
        }

        return {
          id: ctId,
          name: ct.name_short || ct.name,
          price: ct.price ? ('€ ' + parseFloat(ct.price).toFixed(2)) : '',
          desc: ct.name || '',
          url: ct.url || '',
          product_model: ct.product_model || mapProductType(ct.product_type || ''),
          shopifyId: ct.id_product || null,
          id_main: ct.id_main || null,
          slug_cat: ct.slug_cat || '',
          sizes: ct.sizes || []
        };
      });
      // Risolvi il case_type del deep-link (product_model -> id reale) PRIMA delle
      // validazioni sottostanti, così Tough non viene resettato a Vegan Leather.
      resolveRequestedCaseType();
      if (CASE_TYPES.length && !state.caseType) {
        state.caseType = CASE_TYPES[0].id;
      }
      if (CASE_TYPES.length && !CASE_TYPES.find(function (t) { return t.id === state.caseType; })) {
        state.caseType = CASE_TYPES[0].id;
      }

      var activeColors = CASE_COLORS[state.caseType] || [];
      if (activeColors.length && !activeColors.find(function (c) { return c.id === state.caseColor; })) {
        state.caseColor = activeColors[0].id;
      }

      buildCaseTypes();
      rebuildCaseTypesForModel();
    } else {
      ensureFallbackCaseTypes(false);
    }

    /* Text palette */
    if (cfg.palette && cfg.palette.length) {
      TEXT_COLORS.length = 0;
      cfg.palette.forEach(function (p) {
        TEXT_COLORS.push({
          hex: p.code_color_1 || '#000',
          name: p.color_name || p.color_slug,
          slug: p.color_slug
        });
      });
      buildTextColors();
      if (TEXT_COLORS.length) {
        var defaultSlug = cfg.default_color || TEXT_COLORS[0].slug;
        var found = TEXT_COLORS.find(function (c) { return c.slug === defaultSlug; });
        if (found) {
          state.selectedTextColor = found.hex;
          state.selectedTextColorSlug = found.slug;
        }
      }
      ORIGINAL_TEXT_COLORS = cloneTextPalette(TEXT_COLORS);
    }

    /* Fonts */
    if (cfg.fonts && cfg.fonts.length) {
      FONTS.length = 0;
      cfg.fonts.forEach(function (f) {
        var cssFamily = getGoogleStudioFamilyByLabel(f.name);
        FONTS.push({
          family: cssFamily || f.name,
          cssFamily: cssFamily || '',
          label: f.name,
          id: String(f.id),
          file: f.file,
          url: f.url || ''
        });
      });
      mergeExtraStudioFonts();
      loadFontsFromDb(FONTS);
      buildFontList();
      if (FONTS.length) {
        state.selectedFont = FONTS[0].family;
        state.selectedFontId = FONTS[0].id;
      }
    } else {
      FONTS.length = 0;
      mergeExtraStudioFonts();
      loadFontsFromDb(FONTS);
      buildFontList();
      if (FONTS.length) {
        state.selectedFont = FONTS[0].family;
        state.selectedFontId = FONTS[0].id;
      }
    }

    if (cfg.max_char) state.maxChars = parseInt(cfg.max_char, 10);
    if (cfg.text_transform) state.textTransform = cfg.text_transform;

    updateHeaderInfo();
    updateToughBaseVisibility();

    if (state.selectedBaseDesign && isToughCase()) {
      selectToughBase(state.selectedBaseDesign);
    }
  }

  function mapProductType(pt) {
    var map = {
      'phone_case': 'Vegan_Leather_Phone_Case',
      'phone_case_nc': 'Vegan_Leather_Phone_Case',
      'Tough_Phone_Case': 'Tough_Phone_Case'
    };
    return map[pt] || 'Vegan_Leather_Phone_Case';
  }

  var FONT_BASE_URL = API_STUDIO_BASE.replace(/coverlab_studio_base\.php.*/, '');
  /* FONT_BASE_URL aggiornato da refreshApiRootsFromDom in init */
  var _loadedFontFamilies = {};
  var _loadedFontFiles = {};
  var _googleStudioFontsLoaded = false;
  var GOOGLE_STUDIO_FONT_MAP = {
    'times': 'Playfair Display',
    'morning': 'Dancing Script',
    'hand script': 'Great Vibes',
    'bella': 'Cormorant Garamond'
  };
  var EXTRA_STUDIO_FONTS = [
    { label: 'Classic Serif', family: 'Lora' },
    { label: 'Modern Serif', family: 'DM Serif Display' },
    { label: 'Elegant Sans', family: 'Montserrat' },
    { label: 'Clean Sans', family: 'Poppins' },
    { label: 'Signature', family: 'Parisienne' },
    { label: 'Romantic', family: 'Allura' },
    { label: 'Calligraphy', family: 'Cormorant Infant' },
    { label: 'Bold Chic', family: 'Abril Fatface' }
  ];

  function getGoogleStudioFamilyByLabel(label) {
    if (!label) return '';
    var key = String(label).trim().toLowerCase();
    return GOOGLE_STUDIO_FONT_MAP[key] || '';
  }

  function loadGoogleStudioFonts() {
    if (_googleStudioFontsLoaded) return;
    _googleStudioFontsLoaded = true;
    var href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Dancing+Script:wght@400;700&family=Great+Vibes&family=Cormorant+Garamond:wght@400;600;700&family=Lora:wght@400;600;700&family=DM+Serif+Display&family=Montserrat:wght@400;500;600;700&family=Poppins:wght@400;500;600;700&family=Parisienne&family=Allura&family=Cormorant+Infant:wght@400;600;700&family=Abril+Fatface&display=swap';
    if (document.querySelector('link[data-cls-google-studio-fonts="1"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-cls-google-studio-fonts', '1');
    document.head.appendChild(link);
  }

  function mergeExtraStudioFonts() {
    var seen = {};
    FONTS.forEach(function (f) {
      seen[(f.family || '').toLowerCase()] = true;
      seen[(f.label || '').toLowerCase()] = true;
    });
    EXTRA_STUDIO_FONTS.forEach(function (f, idx) {
      var famKey = (f.family || '').toLowerCase();
      var labelKey = (f.label || '').toLowerCase();
      if (seen[famKey] || seen[labelKey]) return;
      FONTS.push({
        family: f.family,
        cssFamily: f.family,
        label: f.label,
        id: 'extra-' + String(idx + 1),
        file: ''
      });
      seen[famKey] = true;
      seen[labelKey] = true;
    });
  }

  function resolveFontFileUrl(file) {
    if (!file) return '';
    var raw = String(file).trim();
    if (!raw) return '';
    if (/^https?:\/\//i.test(raw) || /^\/\//.test(raw)) return raw;
    if (raw.charAt(0) === '/') {
      try {
        return new URL(raw, API_BASE).toString();
      } catch (e) {
        return API_BASE.replace(/\/?$/, '/') + raw.replace(/^\//, '');
      }
    }
    var safePath = raw.split('/').map(function (part) { return encodeURIComponent(part); }).join('/');
    return getAssetBase().replace(/\/?$/, '/') + safePath;
  }

  function loadFontsFromDb(fontList) {
    loadGoogleStudioFonts();
    var style = document.createElement('style');
    var css = '';
    fontList.forEach(function (f) {
      var family = f.cssFamily || f.family || f.name;
      if (!family || _loadedFontFamilies[family]) return;
      _loadedFontFamilies[family] = true;

      if ((f.url || f.file) && !f.cssFamily) {
        var srcFile = f.url || f.file;
        var ext = String(srcFile).split('.').pop().toLowerCase();
        var format = ext === 'otf' ? 'opentype' : ext === 'ttf' ? 'truetype' : ext;
        var url = resolveFontFileUrl(srcFile);
        _loadedFontFiles[family] = url;
        css += '@font-face{font-family:"' + family + '";src:url("' + url + '") format("' + format + '");font-display:swap;}\n';
      }
    });
    if (css) {
      style.textContent = css;
      document.head.appendChild(style);
    }

    if (document.fonts && document.fonts.load) {
      fontList.forEach(function (f) {
        var family = f.cssFamily || f.family || f.name;
        if (!family) return;
        document.fonts.load('16px "' + family + '"').catch(function () {
          if (_loadedFontFiles[family]) {
            console.warn('Studio: font non caricato', family, _loadedFontFiles[family]);
          }
        });
      });
    }
  }

  var apiImageNode = null;
  var _apiImageLayout = null;
  /** Ultimo blocco `camera` dell'API (x,y,w,h,image) per ricalcolo foro in resize. */
  var _lastCameraMeta = null;

  function displayBaseImage(dataUri, cameraMeta) {
    var baseImg = new Image();
    var camImg = null;
    var hasCam = cameraMeta && cameraMeta.image;
    if (hasCam) camImg = new Image();

    var nReady = 0;
    var targetN = hasCam ? 2 : 1;

    function onPieceReady() {
      nReady++;
      if (nReady < targetN) return;
      applyDisplayBaseAndCamera(baseImg, hasCam ? cameraMeta : null, hasCam ? camImg : null);
    }

    baseImg.onload = onPieceReady;
    baseImg.onerror = onPieceReady;
    if (hasCam) {
      camImg.onload = onPieceReady;
      camImg.onerror = onPieceReady;
      camImg.src = cameraMeta.image;
    }
    baseImg.src = dataUri;
  }

  function applyDisplayBaseAndCamera(img, cameraMeta, camImageEl) {
    var sw = stage.width();
    var sh = stage.height();
    var padding = 30;
    var imgAspect = img.width / img.height;
    var availW = sw - padding * 2;
    var availH = sh - padding * 2;
    var dispW, dispH;
    if (availW / availH > imgAspect) {
      dispH = availH;
      dispW = dispH * imgAspect;
    } else {
      dispW = availW;
      dispH = dispW / imgAspect;
    }
    var ox = (sw - dispW) / 2;
    var oy = (sh - dispH) / 2;

    _apiImageLayout = {
      ox: ox, oy: oy, dispW: dispW, dispH: dispH,
      srcW: img.width, srcH: img.height,
      scale: dispW / img.width
    };

    if (phoneGroup) phoneGroup.hide();

    if (apiImageNode) {
      apiImageNode.image(img);
      apiImageNode.x(ox);
      apiImageNode.y(oy);
      apiImageNode.width(dispW);
      apiImageNode.height(dispH);
      apiImageNode.show();
    } else {
      apiImageNode = new Konva.Image({
        image: img,
        x: ox, y: oy,
        width: dispW, height: dispH,
        listening: false,
        name: 'apiBasePreview'
      });
      bgLayer.add(apiImageNode);
    }
    bgLayer.batchDraw();

    var scale = _apiImageLayout.scale;
    var edgeInset = dispW * 0.045;
    var pb = {
      x: ox + edgeInset,
      y: oy + edgeInset,
      w: dispW - edgeInset * 2,
      h: dispH - edgeInset * 2
    };
    printLayer._printBounds = pb;

    var cornerR = Math.max(0, getCoverCornerRadius() * scale);
    printLayer.clipFunc(function (ctx) {
      ctx.beginPath();
      ctx.moveTo(pb.x + cornerR, pb.y);
      ctx.lineTo(pb.x + pb.w - cornerR, pb.y);
      ctx.arcTo(pb.x + pb.w, pb.y, pb.x + pb.w, pb.y + cornerR, cornerR);
      ctx.lineTo(pb.x + pb.w, pb.y + pb.h - cornerR);
      ctx.arcTo(pb.x + pb.w, pb.y + pb.h, pb.x + pb.w - cornerR, pb.y + pb.h, cornerR);
      ctx.lineTo(pb.x + cornerR, pb.y + pb.h);
      ctx.arcTo(pb.x, pb.y + pb.h, pb.x, pb.y + pb.h - cornerR, cornerR);
      ctx.lineTo(pb.x, pb.y + cornerR);
      ctx.arcTo(pb.x, pb.y, pb.x + cornerR, pb.y, cornerR);
      ctx.closePath();
    });
    printLayer.batchDraw();

    showApiLoadingIndicator(false);
    state.awaitingApiBase = false;
    state.useApiBase = true;

    if (cameraMeta && camImageEl && camImageEl.naturalWidth) {
      placeCameraOverlay(cameraMeta, camImageEl);
    } else if (cameraMeta) {
      placeCameraOverlay(cameraMeta, null);
    } else {
      _lastCameraMeta = null;
      overlayLayer.destroyChildren();
      _cameraOverlayNode = null;
      overlayLayer.batchDraw();
    }

    applyBaseDesignFromQueryAfterLayout();
  }

  /** Grafica prodotto da query (?base_design=…) dopo che l’area stampa è allineata alla PNG API. */
  function applyBaseDesignFromQueryAfterLayout() {
    if (!state.baseDesignUrl || !printLayer || !printLayer._printBounds) return;
    destroyProductGraphicNodes();
    loadBaseDesign(state.baseDesignUrl);
    state._baseLoaded = true;
  }

  function relayoutApiBaseOnResize() {
    if (!apiImageNode) return;
    var img = apiImageNode.image();
    if (!img || !img.width) return;
    var preloadedCam = null;
    if (_cameraOverlayNode && _cameraOverlayNode.image) {
      var cimg = _cameraOverlayNode.image();
      if (cimg && cimg.naturalWidth) preloadedCam = cimg;
    }
    applyDisplayBaseAndCamera(img, _lastCameraMeta, preloadedCam);
  }


  /* ═══════════════════════════════════════════════════════
     CAMERA OVERLAY — loads foro as separate layer on top
     ═══════════════════════════════════════════════════════ */

  var _cameraOverlayNode = null;

  function loadCameraOverlay() {
    if (!_apiImageLayout) return;

    overlayLayer.destroyChildren();
    _cameraOverlayNode = null;
    overlayLayer.batchDraw();

    fetch(getCameraApiUrl())
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.camera && data.camera.image) {
          placeCameraOverlay(data.camera, null);
        }
      })
      .catch(function (err) {
        console.warn('Camera overlay load failed:', err);
      });
  }

  function placeCameraOverlay(cam, preloadedImage) {
    if (!_apiImageLayout) return;
    _lastCameraMeta = cam || null;
    var layout = _apiImageLayout;
    var scale = layout.scale;
    var cx = layout.ox + cam.x * scale;
    var cy = layout.oy + cam.y * scale;
    var cw = cam.width * scale;
    var ch = cam.height * scale;

    function addToOverlay(konvaImage) {
      overlayLayer.destroyChildren();
      _cameraOverlayNode = null;
      _cameraOverlayNode = new Konva.Image({
        image: konvaImage,
        x: cx, y: cy,
        width: cw, height: ch,
        listening: false,
        name: 'cameraOverlay'
      });
      overlayLayer.add(_cameraOverlayNode);
      overlayLayer.batchDraw();
    }

    if (preloadedImage && preloadedImage.naturalWidth) {
      addToOverlay(preloadedImage);
      return;
    }

    var camImg = new Image();
    camImg.onload = function () { addToOverlay(camImg); };
    camImg.onerror = function () { overlayLayer.batchDraw(); };
    camImg.src = cam.image;
  }

  function showApiLoadingIndicator(show) {
    var el = document.getElementById('cls-api-loading');
    if (!el) return;
    el.style.display = show ? 'flex' : 'none';
  }

  /* ═══════════════════════════════════════════════════════
     CANVAS SETUP
     ═══════════════════════════════════════════════════════ */

  function initCanvas() {
    var container = document.getElementById('cls-canvas-container');
    stage = new Konva.Stage({
      container: 'cls-canvas-container',
      width: container.offsetWidth,
      height: container.offsetHeight
    });

    bgLayer = new Konva.Layer();
    printLayer = new Konva.Layer();
    overlayLayer = new Konva.Layer({ listening: false });
    uiLayer = new Konva.Layer();

    stage.add(bgLayer);
    stage.add(printLayer);
    stage.add(overlayLayer);
    stage.add(uiLayer);

    transformer = new Konva.Transformer({
      borderStroke: '#1a1a1a',
      borderStrokeWidth: 1.5,
      anchorStroke: '#1a1a1a',
      anchorFill: '#ffffff',
      anchorSize: 10,
      anchorCornerRadius: 5,
      rotateAnchorOffset: 24,
      enabledAnchors: ['top-left','top-right','bottom-left','bottom-right'],
      rotateEnabled: true,
      keepRatio: true,
      padding: 4
    });
    uiLayer.add(transformer);

    stage.on('tap click', function (e) {
      if (e.target === stage || (phoneGroup && e.target.getParent() === phoneGroup)) {
        transformer.nodes([]);
        uiLayer.batchDraw();
        document.getElementById('cls-delete-selected').style.display = 'none';
      }
    });
  }

  function onResize() {
    var container = document.getElementById('cls-canvas-container');
    stage.width(container.offsetWidth);
    stage.height(container.offsetHeight);
    if (state.useApiBase && apiImageNode && apiImageNode.image()) {
      relayoutApiBaseOnResize();
    } else {
      drawPhone();
    }
  }

  /* ═══════════════════════════════════════════════════════
     DRAW PHONE OUTLINE
     ═══════════════════════════════════════════════════════ */

  function drawPhone() {
    if (printGroup) printGroup.destroyChildren();

    var dims = PHONE_DIMS[state.phoneModel] || PHONE_DIMS['default'];
    var sw = stage.width();
    var sh = stage.height();
    var padding = 30;
    var phoneAspect = dims.w / dims.h;
    var availW = sw - padding * 2;
    var availH = sh - padding * 2;
    var phoneW, phoneH;

    if (availW / availH > phoneAspect) {
      phoneH = availH;
      phoneW = phoneH * phoneAspect;
    } else {
      phoneW = availW;
      phoneH = phoneW / phoneAspect;
    }

    currentScale = phoneW / dims.w;
    var edgeS = CASE_EDGE * currentScale;

    if (state.useApiBase && apiImageNode) {
      var aimg = apiImageNode.image();
      if (aimg && aimg.width) {
        relayoutApiBaseOnResize();
        return;
      }
    }

    bgLayer.destroyChildren();
    apiImageNode = null;
    _apiImageLayout = null;
    phoneGroup = null;
    caseShape = null;
    state.useApiBase = false;

    setupPrintArea(edgeS, phoneW, phoneH, dims);

    /* Finché la prima risposta API non è arrivata: solo area stampa + overlay loading, niente rettangolo finto. */
    if (state.awaitingApiBase) {
      bgLayer.batchDraw();
      return;
    }

    /* Base API assente: mock vettoriale (errore API, solo offline, o cambio colore/cover senza API). */
    var colors = getColors();
    var caseHex = colors ? colors.hex : '#1a1a1a';
    var ox = (sw - phoneW) / 2;
    var oy = (sh - phoneH) / 2;

    phoneGroup = new Konva.Group({ x: ox, y: oy });

    var shadow = new Konva.Rect({
      width: phoneW + 16, height: phoneH + 16,
      x: -8, y: -4,
      cornerRadius: (dims.r + 4) * currentScale,
      fill: 'black',
      opacity: 0.12,
      filters: [Konva.Filters.Blur],
      blurRadius: 24
    });

    var frameOuter = new Konva.Rect({
      x: -3, y: -3,
      width: phoneW + 6, height: phoneH + 6,
      cornerRadius: (dims.r + 2) * currentScale,
      fill: '#c0c0c0',
      stroke: '#a0a0a0',
      strokeWidth: 0.5
    });

    caseShape = new Konva.Rect({
      width: phoneW, height: phoneH,
      cornerRadius: dims.r * currentScale,
      fill: caseHex,
      stroke: '#d0d0d0',
      strokeWidth: 0.5
    });

    var printW = phoneW - edgeS * 2;
    var printH = phoneH - edgeS * 2;

    var printBg = new Konva.Rect({
      x: edgeS, y: edgeS,
      width: printW, height: printH,
      cornerRadius: (dims.r - CASE_EDGE) * currentScale,
      fill: caseHex,
      listening: false
    });

    var camSize = dims.camW * currentScale;
    var camX = phoneW - edgeS - camSize + 10 * currentScale;
    var camY = edgeS + 20 * currentScale;
    var camCutout = new Konva.Rect({
      x: camX, y: camY,
      width: camSize, height: camSize,
      cornerRadius: 20 * currentScale,
      fill: '#d8d8d8',
      stroke: '#c0c0c0',
      strokeWidth: 1
    });
    var camLens1 = new Konva.Circle({
      x: camX + camSize * 0.35, y: camY + camSize * 0.35,
      radius: camSize * 0.15,
      fill: '#1a1a2e', stroke: '#555', strokeWidth: 1.5
    });
    var camLens2 = new Konva.Circle({
      x: camX + camSize * 0.65, y: camY + camSize * 0.35,
      radius: camSize * 0.15,
      fill: '#1a1a2e', stroke: '#555', strokeWidth: 1.5
    });
    var camLens3 = new Konva.Circle({
      x: camX + camSize * 0.5, y: camY + camSize * 0.65,
      radius: camSize * 0.15,
      fill: '#1a1a2e', stroke: '#555', strokeWidth: 1.5
    });

    phoneGroup.add(shadow, frameOuter, caseShape, printBg, camCutout, camLens1, camLens2, camLens3);
    bgLayer.add(phoneGroup);

    try { shadow.cache(); } catch (e) { /* skip cache on error */ }

    bgLayer.batchDraw();

    if (state.baseDesignUrl && !state._baseLoaded) {
      loadBaseDesign(state.baseDesignUrl);
      state._baseLoaded = true;
    }
  }

  function setupPrintArea(edgeS, phoneW, phoneH, dims) {
    var pw = phoneW - edgeS * 2 - PRINT_PADDING * 2 * currentScale;
    var ph = phoneH - edgeS * 2 - PRINT_PADDING * 2 * currentScale;
    var px = (stage.width() - phoneW) / 2 + edgeS + PRINT_PADDING * currentScale;
    var py = (stage.height() - phoneH) / 2 + edgeS + PRINT_PADDING * currentScale;

    printLayer.clipFunc(function (ctx) {
      var r = Math.max(0, (dims.r - CASE_EDGE - PRINT_PADDING) * currentScale);
      ctx.beginPath();
      ctx.moveTo(px + r, py);
      ctx.lineTo(px + pw - r, py);
      ctx.arcTo(px + pw, py, px + pw, py + r, r);
      ctx.lineTo(px + pw, py + ph - r);
      ctx.arcTo(px + pw, py + ph, px + pw - r, py + ph, r);
      ctx.lineTo(px + r, py + ph);
      ctx.arcTo(px, py + ph, px, py + ph - r, r);
      ctx.lineTo(px, py + r);
      ctx.arcTo(px, py, px + r, py, r);
      ctx.closePath();
    });

    printLayer._printBounds = { x: px, y: py, w: pw, h: ph };
    printLayer.batchDraw();
    if (state.mode === 'collage') { renderCollageOnCanvas(); }
  }

  function getColors() {
    var list = CASE_COLORS[state.caseType] || [];
    if (!list.length) {
      for (var k in CASE_COLORS) { if (CASE_COLORS[k].length) { list = CASE_COLORS[k]; break; } }
    }
    return list.find(function (c) { return c.id === state.caseColor; }) || list[0] || { hex: '#1a1a1a', name: 'Black', id: 'black' };
  }

  /**
   * Grafica prodotto (PNG) nell’area stampa: Konva.Image su printLayer in fondo (sopra la custodia
   * perché printLayer è sopra bgLayer; sticker sopra la grafica). crossOrigin solo same-origin,
   * altrimenti molti CDN / MAMP senza CORS bloccano il disegno su canvas.
   */
  function shouldSetAnonymousCrossOriginForGraphic(url) {
    if (typeof window === 'undefined' || !window.location) return false;
    try {
      var u = new URL(url, window.location.href);
      return u.origin === window.location.origin;
    } catch (e) {
      return false;
    }
  }

  function loadBaseDesign(url) {
    var resolved = resolveStudioGraphicUrl(url);
    var img = new Image();
    if (shouldSetAnonymousCrossOriginForGraphic(resolved)) {
      img.crossOrigin = 'anonymous';
    }
    img.onerror = function () {
      console.warn('Studio: impossibile caricare la grafica base', resolved);
    };
    img.onload = function () {
      var b = printLayer._printBounds;
      if (!b) return;
      destroyProductGraphicNodes();

      var kImg = new Konva.Image({
        image: img,
        x: b.x,
        y: b.y,
        width: b.w,
        height: b.h,
        listening: false,
        name: 'baseDesign'
      });
      printLayer.add(kImg);
      kImg.moveToBottom();
      printLayer.batchDraw();
      bgLayer.batchDraw();
    };
    img.src = resolved;
  }

  /* ═══════════════════════════════════════════════════════
     SIDEBAR BUILD
     ═══════════════════════════════════════════════════════ */

  function buildSidebar() {
    buildModelGroups();
    buildCaseTypes();
    buildColorSwatches();
    buildFontList();
    buildTextColors();
    buildLayoutPresets();
    buildCollageLayoutPicker();
    buildCollageSlots();
  }

  function buildModelGroups() {
    var container = document.getElementById('cls-model-groups');
    if (!container) return;
    container.innerHTML = '';

    if (!PHONE_GROUPS.length) {
      container.innerHTML = '<div class="cls-model-group__label" style="opacity:.5">Caricamento modelli…</div>';
      return;
    }

    PHONE_GROUPS.forEach(function (g) {
      var div = document.createElement('div');
      div.className = 'cls-model-group';
      var lbl = document.createElement('div');
      lbl.className = 'cls-model-group__label';
      lbl.textContent = g.label;
      div.appendChild(lbl);
      var list = document.createElement('div');
      list.className = 'cls-model-list';
      g.models.forEach(function (m) {
        var isActive = m.id === state.phoneModel;
        var btn = document.createElement('button');
        btn.className = 'cls-model-btn' + (isActive ? ' active' : '');
        btn.textContent = m.name;
        btn.dataset.model = m.id;

        var isAvailable = checkModelAvailability(m.id);
        if (!isAvailable) {
          btn.style.display = 'none';
          return;
        }

        btn.addEventListener('click', function () {
          state.phoneModel = m.id;
          container.querySelectorAll('.cls-model-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          rebuildCaseTypesForModel();
          updateHeaderInfo();
          drawPhoneUnlessUsingApi();
          refreshBasePreservingDesign();
        });
        list.appendChild(btn);
      });
      div.appendChild(list);

      var visibleBtns = list.querySelectorAll('.cls-model-btn:not([style*="display: none"])');
      if (!visibleBtns.length) {
        div.style.display = 'none';
      }

      container.appendChild(div);
    });
  }

  function checkModelAvailability(modelSlug) {
    // Un modello è proponibile se ALMENO UN cover type lo ha disponibile in
    // almeno un colore (lo step modello viene prima della scelta del tipo).
    var typeIds = Object.keys(DB_OPTIONS_BY_TYPE);
    if (typeIds.length) {
      return typeIds.some(function (tid) {
        var opts = DB_OPTIONS_BY_TYPE[tid][modelSlug];
        return opts && opts.some(function (o) { return o.available === 1; });
      });
    }
    if (!DB_OPTIONS || !Object.keys(DB_OPTIONS).length) return true;
    var opts = DB_OPTIONS[modelSlug];
    if (!opts) return false;
    return opts.some(function (o) { return o.available === 1; });
  }


  function isTypeSoldOutForModel(ct) {
    // Sold out SOLO se abbiamo dati espliciti e nessun colore disponibile
    // (righe mancanti in items_main_options = disponibilità ignota, non sold out).
    if (!ct) return false;
    var typeOpts = DB_OPTIONS_BY_TYPE[ct.id];
    var opts = typeOpts && typeOpts[state.phoneModel];
    if (!opts || !opts.length) return false;
    return !opts.some(function (o) { return o.available === 1; });
  }

  function getCompatibleCaseTypes() {
    if (!CASE_TYPES.length) return [];
    var modelLower = (state.phoneModel || '').toLowerCase().replace(/ /g, '_');
    return CASE_TYPES.filter(function (ct) {
      if (!ct.sizes || !ct.sizes.length) return true;
      return ct.sizes.some(function (s) {
        return s.toLowerCase().replace(/ /g, '_') === modelLower;
      });
    });
  }

  function rebuildCaseTypesForModel() {
    var grid = document.getElementById('cls-casetype-grid');
    if (!grid) return;
    grid.innerHTML = '';

    var compatible = getCompatibleCaseTypes();
    if (!compatible.length) return;

    if (!compatible.find(function (ct) { return ct.id === state.caseType; })) {
      state.caseType = compatible[0].id;
      var firstColor = (CASE_COLORS[compatible[0].id] || [])[0];
      if (firstColor) state.caseColor = firstColor.id;
    }

    compatible.forEach(function (ct) {
      var soldOut = isTypeSoldOutForModel(ct);
      var btn = document.createElement('button');
      btn.className = 'cls-casetype-btn' + (ct.id === state.caseType ? ' active' : '');
      if (soldOut) btn.style.opacity = '0.55';
      btn.innerHTML = '<span>' + ct.name + '</span>' +
        (ct.desc ? '<small>' + ct.desc + '</small>' : '') +
        (ct.price ? '<small>' + ct.price + '</small>' : '') +
        (soldOut ? '<small style="color:#9a4b2f;font-weight:600;">Sold out</small>' : '');
      btn.dataset.casetype = ct.id;
      btn.addEventListener('click', function () {
        state.caseType = ct.id;
        grid.querySelectorAll('.cls-casetype-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        updateHeaderInfo();
        var firstColor = (CASE_COLORS[ct.id] || [])[0];
        if (firstColor) state.caseColor = firstColor.id;
        buildColorSwatches();
        updateToughBaseVisibility();
        drawPhoneUnlessUsingApi();
        refreshBasePreservingDesign();
      });
      grid.appendChild(btn);
    });

    buildColorSwatches();
    updateToughBaseVisibility();
  }

  function buildCaseTypes() {
    var grid = document.getElementById('cls-casetype-grid');
    if (!grid) return;
    grid.innerHTML = '';

    if (!CASE_TYPES.length) {
      grid.innerHTML = '<div style="font-size:12px;opacity:.5;padding:8px">Caricamento tipi cover…</div>';
      return;
    }

    CASE_TYPES.forEach(function (ct) {
      var soldOut = isTypeSoldOutForModel(ct);
      var btn = document.createElement('button');
      btn.className = 'cls-casetype-btn' + (ct.id === state.caseType ? ' active' : '');
      if (soldOut) btn.style.opacity = '0.55';
      btn.innerHTML = '<span>' + ct.name + '</span>' +
        (ct.desc ? '<small>' + ct.desc + '</small>' : '') +
        (ct.price ? '<small>' + ct.price + '</small>' : '') +
        (soldOut ? '<small style="color:#9a4b2f;font-weight:600;">Sold out</small>' : '');
      btn.dataset.casetype = ct.id;
      btn.addEventListener('click', function () {
        state.caseType = ct.id;
        grid.querySelectorAll('.cls-casetype-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        updateHeaderInfo();
        var firstColor = (CASE_COLORS[ct.id] || [])[0];
        if (firstColor) state.caseColor = firstColor.id;
        buildColorSwatches();
        updateToughBaseVisibility();
        drawPhoneUnlessUsingApi();
        refreshBasePreservingDesign();
      });
      grid.appendChild(btn);
    });
    updateToughBaseVisibility();
  }

  function buildColorSwatches() {
    var container = document.getElementById('cls-color-swatches');
    if (!container) return;
    container.innerHTML = '';
    var list = CASE_COLORS[state.caseType] || [];

    var colorStep = document.getElementById('cls-color-step');

    // Tough: colore unico "Blank" → nascondi del tutto lo step Case Color
    if (isToughCase()) {
      if (colorStep) colorStep.style.display = 'none';
      state.caseColor = 'blank';
      return;
    }

    if (!list.length) {
      container.innerHTML = '<div style="font-size:12px;opacity:.5;padding:4px">Caricamento colori…</div>';
      if (colorStep) colorStep.style.display = '';
      return;
    }

    var available = getAvailableColors(list);
    // Fallback "mostra tutti" SOLO quando la disponibilità non è nota (dati
    // mancanti). Se i dati ci sono ed è tutto a 0 → sold out reale: mostrare
    // tutti i pallini era fuorviante (es. Clear MagSafe su iPhone 17 Pro).
    var typeOpts = DB_OPTIONS_BY_TYPE[state.caseType];
    var hasAvailabilityData = !!(typeOpts && typeOpts[state.phoneModel] && typeOpts[state.phoneModel].length);
    if (!available.length && !hasAvailabilityData) available = list;

    if (!available.length) {
      if (colorStep) colorStep.style.display = '';
      container.innerHTML = '<div style="font-size:13px;padding:10px 4px;color:#9a4b2f;">' +
        'Sold out per questo modello al momento — scegli un altro modello o tipo di cover.</div>';
      return;
    }

    var isSingleBlank = available.length === 1 && available[0].id === 'blank';
    if (isSingleBlank || available.length === 0) {
      if (colorStep) colorStep.style.display = 'none';
      state.caseColor = available.length ? available[0].id : 'blank';
      return;
    }

    if (colorStep) colorStep.style.display = '';

    if (!available.find(function (c) { return c.id === state.caseColor; })) {
      state.caseColor = available[0].id;
    }

    available.forEach(function (c) {
      var sw = document.createElement('button');
      sw.className = 'cls-swatch' + (c.id === state.caseColor ? ' active' : '');
      sw.style.background = c.hex;
      sw.dataset.color = c.id;
      sw.dataset.name = c.name;
      sw.title = c.name;
      sw.addEventListener('click', function () {
        state.caseColor = c.id;
        container.querySelectorAll('.cls-swatch').forEach(function (s) { s.classList.remove('active'); });
        sw.classList.add('active');
        updateHeaderInfo();
        drawPhoneUnlessUsingApi();
        refreshBasePreservingDesign();
      });
      container.appendChild(sw);
    });
  }

  function getAvailableColors(colorList) {
    // Filtra SOLO con le disponibilità del tipo selezionato. DB_OPTIONS globale
    // appartiene al tipo del config iniziale: usarla per gli altri tipi
    // nascondeva colori disponibili (bug pallino "clear" sulle MagSafe).
    var typeOpts = DB_OPTIONS_BY_TYPE[state.caseType];
    if (!typeOpts) return colorList;
    var opts = typeOpts[state.phoneModel];
    if (!opts) return colorList;

    return colorList.filter(function (c) {
      var opt = opts.find(function (o) { return o.slug_color === c.id; });
      return opt && opt.available === 1;
    });
  }

  /* ═══════════════════════════════════════════════════════
     TOUGH BASE DESIGN SELECTOR
     ═══════════════════════════════════════════════════════ */

  var _toughBasesLoaded = false;

  function isToughCase() {
    if (state.caseType === 'Tough_Phone_Case') return true;
    var ct = CASE_TYPES.find(function (t) { return t.id === state.caseType; });
    return ct && ct.product_model === 'Tough_Phone_Case';
  }

  function updateToughBaseVisibility() {
    var step = document.getElementById('cls-base-design-step');
    if (!step) return;
    var tough = isToughCase();
    // Tab mobile: per Tough mostra "Base" e nascondi "Color"; viceversa per gli altri.
    document.querySelectorAll('.cls-tab--tough-only').forEach(function (el) {
      el.style.display = tough ? '' : 'none';
    });
    document.querySelectorAll('.cls-tab--notough').forEach(function (el) {
      el.style.display = tough ? 'none' : '';
    });
    if (tough) {
      step.style.display = '';
      if (!_toughBasesLoaded) loadToughBases();
      if (state.selectedBaseDesign) {
        applyAutoTextPaletteForToughBase(state.selectedBaseDesign);
      }
    } else {
      step.style.display = 'none';
      if (ORIGINAL_TEXT_COLORS.length) {
        applyTextPalette(cloneTextPalette(ORIGINAL_TEXT_COLORS), { applyToSelectedText: false });
      }
    }
  }

  function loadToughBases() {
    var loading = document.getElementById('cls-base-loading');
    if (loading) loading.style.display = 'flex';

    var apiSize = getApiSize(state.phoneModel);
    var url = API_STUDIO_BASE + '&action=tough_bases&cmt_size=' + encodeURIComponent(apiSize);

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.bases && data.bases.length) {
          state.toughBases = data.bases;
          _toughBasesLoaded = true;
          buildBaseGrid();
        }
        if (loading) loading.style.display = 'none';
      })
      .catch(function (err) {
        console.error('Failed to load tough bases:', err);
        if (loading) loading.style.display = 'none';
      });
  }

  function buildBaseGrid() {
    var grid = document.getElementById('cls-base-grid');
    if (!grid) return;
    grid.innerHTML = '';

    state.toughBases.forEach(function (base) {
      var tile = document.createElement('div');
      tile.className = 'cls-base-tile';

      var card = document.createElement('div');
      card.className = 'cls-base-card' +
        (state.selectedBaseDesign === base.codice_design ? ' active' : '');
      card.dataset.codice = base.codice_design;

      var img = document.createElement('img');
      img.src = base.thumb;
      img.alt = base.name;
      img.loading = 'lazy';

      card.appendChild(img);
      tile.appendChild(card);

      tile.addEventListener('click', function () {
        selectToughBase(base.codice_design);
        grid.querySelectorAll('.cls-base-card').forEach(function (c) { c.classList.remove('active'); });
        card.classList.add('active');
      });

      grid.appendChild(tile);
    });
  }

  function selectToughBase(codiceDesign) {
    state.selectedBaseDesign = codiceDesign;
    applyAutoTextPaletteForToughBase(codiceDesign);
    showApiLoadingIndicator(true);

    var apiSize = getApiSize(state.phoneModel);
    var urlTough = API_STUDIO_BASE +
      '&action=render_tough_base' +
      '&codice_design=' + encodeURIComponent(codiceDesign) +
      '&cmt_size=' + encodeURIComponent(apiSize);

    var camF = fetch(getCameraApiUrl())
      .then(function (r) { return r.json(); })
      .catch(function () { return {}; });

    Promise.all([fetch(urlTough).then(function (r) { return r.json(); }), camF])
      .then(function (results) {
        var data = results[0];
        var dataCam = results[1];
        if (data && data.image) {
          var cam = (dataCam && dataCam.camera && dataCam.camera.image) ? dataCam.camera : null;
          displayBaseImage(data.image, cam);
        } else {
          showApiLoadingIndicator(false);
        }
      })
      .catch(function (err) {
        console.error('Failed to render tough base:', err);
        showApiLoadingIndicator(false);
      });
  }

  function buildFontList() {
    var container = document.getElementById('cls-font-list');
    if (!container) return;
    container.innerHTML = '';
    if (!FONTS.length) {
      container.innerHTML = '<div style="font-size:12px;opacity:.5;padding:8px">Caricamento font…</div>';
      return;
    }
    FONTS.forEach(function (f, idx) {
      var btn = document.createElement('button');
      btn.className = 'cls-font-btn' + (f.family === state.selectedFont ? ' active' : '');
      btn.style.fontFamily = "'" + f.family + "', sans-serif";
      btn.textContent = f.label;
      btn.dataset.font = f.family;
      btn.dataset.fontid = f.id || String(idx + 1);
      btn.addEventListener('click', function () {
        state.selectedFont = f.family;
        state.selectedFontId = f.id || String(idx + 1);
        container.querySelectorAll('.cls-font-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        updateSelectedText({ fontFamily: f.family });
      });
      container.appendChild(btn);
    });
  }

  function applyFontToNodes(nodes, fontFamily) {
    if (!nodes || !nodes.length || !fontFamily) return false;
    var changed = false;
    nodes.forEach(function (n) {
      if (!(n instanceof Konva.Text)) return;
      n.fontFamily(fontFamily);
      n.offsetX(n.width() / 2);
      n.offsetY(n.height() / 2);
      changed = true;
    });
    return changed;
  }

  function buildTextColors() {
    var container = document.getElementById('cls-text-colors');
    if (!container) return;
    container.innerHTML = '';
    if (!TEXT_COLORS.length) {
      container.innerHTML = '<div style="font-size:12px;opacity:.5;padding:4px">Caricamento colori testo…</div>';
      return;
    }
    TEXT_COLORS.forEach(function (c) {
      var btn = document.createElement('button');
      btn.className = 'cls-text-color' + (c.hex === state.selectedTextColor ? ' active' : '');
      btn.style.background = c.hex;
      btn.dataset.tcolor = c.hex;
      btn.title = c.name;
      btn.addEventListener('click', function () {
        state.selectedTextColor = c.hex;
        state.selectedTextColorSlug = c.slug || c.name.toLowerCase().replace(/\s+/g, '');
        container.querySelectorAll('.cls-text-color').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        updateSelectedText({ fill: c.hex });
      });
      container.appendChild(btn);
    });

    // Selettore libero: permette un colore personalizzato oltre alla palette suggerita.
    var pickerWrap = document.createElement('label');
    pickerWrap.className = 'cls-text-color cls-text-color--picker';
    pickerWrap.title = 'Scegli un colore personalizzato';
    pickerWrap.style.position = 'relative';
    pickerWrap.style.overflow = 'hidden';

    var picker = document.createElement('input');
    picker.type = 'color';
    picker.value = normalizeHexColor(state.selectedTextColor || '#000000');
    picker.setAttribute('aria-label', 'Scegli colore testo');
    picker.style.position = 'absolute';
    picker.style.inset = '0';
    picker.style.opacity = '0';
    picker.style.cursor = 'pointer';
    picker.style.width = '100%';
    picker.style.height = '100%';
    picker.style.border = '0';
    picker.style.padding = '0';

    picker.addEventListener('input', function () {
      var hex = normalizeHexColor(picker.value);
      state.selectedTextColor = hex;
      state.selectedTextColorSlug = 'custom';
      container.querySelectorAll('.cls-text-color').forEach(function (b) { b.classList.remove('active'); });
      pickerWrap.classList.add('active');
      updateSelectedText({ fill: hex });
    });

    pickerWrap.appendChild(picker);
    container.appendChild(pickerWrap);
  }

  function buildLayoutPresets() {
    var container = document.getElementById('cls-layout-presets');
    container.innerHTML = '';
    LAYOUT_PRESETS.forEach(function (p) {
      var btn = document.createElement('button');
      btn.className = 'cls-preset-btn';
      btn.dataset.preset = p.id;
      var iconDiv = document.createElement('div');
      iconDiv.className = 'cls-preset-icon';
      var line = document.createElement('span');
      line.textContent = 'Aa';
      if (p.id === 'center') { line.style.cssText = 'top:50%;left:50%;transform:translate(-50%,-50%)'; }
      else if (p.id === 'bottom') { line.style.cssText = 'bottom:4px;left:50%;transform:translateX(-50%)'; }
      else if (p.id === 'top') { line.style.cssText = 'top:4px;left:50%;transform:translateX(-50%)'; }
      else if (p.id === 'diagonal') { line.style.cssText = 'top:50%;left:50%;transform:translate(-50%,-50%) rotate(-25deg)'; }
      iconDiv.appendChild(line);
      btn.appendChild(iconDiv);
      var label = document.createElement('span');
      label.textContent = p.name;
      btn.appendChild(label);
      btn.addEventListener('click', function () {
        container.querySelectorAll('.cls-preset-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state.selectedLayoutId = p.apiId || String(LAYOUT_PRESETS.indexOf(p) + 1);
        applyLayoutPreset(p);
      });
      container.appendChild(btn);
    });
  }

  /* ═══════════════════════════════════════════════════════
     ACCORDION & NAVIGATION
     ═══════════════════════════════════════════════════════ */

  function bindAccordion() {
    document.querySelectorAll('[data-step-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stepId = btn.dataset.stepToggle;
        toggleStep(stepId);
      });
    });
  }

  function toggleStep(stepId) {
    var step = document.querySelector('.cls-step[data-step="' + stepId + '"]');
    if (!step) return;
    if (step.classList.contains('open')) {
      step.classList.remove('open');
    } else {
      openStep(stepId);
    }
  }

  function openStep(stepId) {
    document.querySelectorAll('.cls-step').forEach(function (s) { s.classList.remove('open'); });
    var step = document.querySelector('.cls-step[data-step="' + stepId + '"]');
    if (step) step.classList.add('open');
    state.currentStep = stepId;
    updateStepCounter();
  }

  function updateStepCounter() {
    var allSteps = document.querySelectorAll('.cls-step:not([style*="display: none"])');
    var total = allSteps.length;
    var currentIdx = 0;
    allSteps.forEach(function (s, i) {
      if (s.dataset.step === String(state.currentStep)) currentIdx = i;
    });
    var display = String(currentIdx + 1).padStart(2, '0');
    var totalStr = String(total).padStart(2, '0');
    var el = document.getElementById('cls-step-counter');
    if (el) el.textContent = display + '/' + totalStr;
  }

  /* ═══════════════════════════════════════════════════════
     MODE SWITCH
     ═══════════════════════════════════════════════════════ */

  /* ═══════════════════════════════════════════════════════
     PHOTO COLLAGE
     ═══════════════════════════════════════════════════════ */

  function buildCollageLayoutPicker() {
    var container = document.getElementById('cls-collage-layouts');
    if (!container) return;
    container.innerHTML = '';

    COLLAGE_LAYOUTS.forEach(function (layout) {
      var btn = document.createElement('button');
      btn.className = 'cls-collage-layout-btn' + (layout.id === state.collageLayout ? ' active' : '');
      btn.dataset.layout = layout.id;
      btn.title = layout.slots + ' foto';

      var icon = document.createElement('div');
      icon.className = 'cls-collage-layout-icon';
      icon.style.setProperty('--cols', layout.cols);
      icon.style.setProperty('--rows', layout.rows);
      for (var c = 0; c < layout.slots; c++) {
        var cell = document.createElement('div');
        cell.className = 'cls-collage-layout-cell';
        icon.appendChild(cell);
      }

      var label = document.createElement('span');
      label.className = 'cls-collage-layout-name';
      label.textContent = layout.slots + ' foto';

      btn.appendChild(icon);
      btn.appendChild(label);

      btn.addEventListener('click', function () {
        state.collageLayout = layout.id;
        state.collagePhotos = {};
        collageImageCache = {};
        container.querySelectorAll('.cls-collage-layout-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        buildCollageSlots();
        renderCollageOnCanvas();
      });

      container.appendChild(btn);
    });
  }

  function buildCollageSlots() {
    var container = document.getElementById('cls-collage-slots');
    if (!container) return;
    container.innerHTML = '';

    var layout = COLLAGE_LAYOUTS.find(function (l) { return l.id === state.collageLayout; });
    if (!layout) return;

    for (var i = 0; i < layout.slots; i++) {
      (function (idx) {
        var slot = document.createElement('div');
        slot.className = 'cls-collage-slot';
        slot.dataset.slotIdx = idx;

        var fi = document.createElement('input');
        fi.type = 'file';
        fi.accept = 'image/*';
        fi.style.display = 'none';
        fi.addEventListener('change', function () { handleCollageSlotFile(fi, idx); });
        slot.appendChild(fi);

        var inner = document.createElement('div');
        inner.className = 'cls-collage-slot__inner';

        if (state.collagePhotos[idx]) {
          var img = document.createElement('img');
          img.src = state.collagePhotos[idx];
          img.className = 'cls-collage-slot__img';
          inner.appendChild(img);
          slot.classList.add('has-photo');

          var rmBtn = document.createElement('button');
          rmBtn.className = 'cls-collage-slot__remove';
          rmBtn.innerHTML = '&times;';
          rmBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            delete state.collagePhotos[idx];
            delete collageImageCache[idx];
            buildCollageSlots();
            renderCollageOnCanvas();
          });
          inner.appendChild(rmBtn);
        } else {
          inner.innerHTML =
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
            '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>' +
            '</svg><span>' + (idx + 1) + '</span>';
        }

        slot.appendChild(inner);
        inner.addEventListener('click', function () { fi.click(); });
        container.appendChild(slot);
      })(i);
    }
  }

  function handleCollageSlotFile(fileInput, idx) {
    var file = fileInput.files[0];
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function (ev) {
      state.collagePhotos[idx] = ev.target.result;
      var img = new Image();
      img.onload = function () {
        collageImageCache[idx] = img;
        buildCollageSlots();
        renderCollageOnCanvas();
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  }

  function renderCollageOnCanvas() {
    if (state.mode !== 'collage') return;
    var b = printLayer && printLayer._printBounds;
    if (!b) return;

    var layout = COLLAGE_LAYOUTS.find(function (l) { return l.id === state.collageLayout; });
    if (!layout) return;

    /* Remove existing collage groups */
    printLayer.find('.collageGroup').forEach(function (n) { n.destroy(); });

    var GAP = 3;

    layout.cells.forEach(function (cell, idx) {
      var gapL = cell.x > 0 ? GAP / 2 : 0;
      var gapT = cell.y > 0 ? GAP / 2 : 0;
      var gapR = (cell.x + cell.w) < 1 - 0.001 ? GAP / 2 : 0;
      var gapB = (cell.y + cell.h) < 1 - 0.001 ? GAP / 2 : 0;

      var cellX = b.x + cell.x * b.w + gapL;
      var cellY = b.y + cell.y * b.h + gapT;
      var cellW = cell.w * b.w - gapL - gapR;
      var cellH = cell.h * b.h - gapT - gapB;

      var group = new Konva.Group({
        x: cellX,
        y: cellY,
        clip: { x: 0, y: 0, width: cellW, height: cellH },
        name: 'collageGroup'
      });

      var cachedImg = collageImageCache[idx];
      if (cachedImg) {
        var sx = cellW / cachedImg.width;
        var sy = cellH / cachedImg.height;
        var sc = Math.max(sx, sy);
        var newW = cachedImg.width * sc;
        var newH = cachedImg.height * sc;
        var imgX = (cellW - newW) / 2;
        var imgY = (cellH - newH) / 2;

        group.add(new Konva.Image({
          image: cachedImg,
          x: imgX, y: imgY,
          width: newW, height: newH,
          listening: false
        }));
      } else {
        group.add(new Konva.Rect({
          x: 0, y: 0, width: cellW, height: cellH,
          fill: '#ebebeb', listening: false
        }));
        group.add(new Konva.Text({
          x: 0, y: cellH / 2 - 12,
          width: cellW,
          text: String(idx + 1),
          fontSize: Math.min(20, cellH * 0.25),
          fill: '#c0c0c0',
          align: 'center',
          listening: false
        }));
      }

      printLayer.add(group);
      group.moveToBottom();
    });

    printLayer.batchDraw();
  }

  function bindModeSwitch() {
    document.querySelectorAll('.cls-mode-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.dataset.mode;
        var prevMode = state.mode;
        state.mode = mode;
        document.querySelectorAll('.cls-mode-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        document.getElementById('cls-app').dataset.mode = mode;
        updateStickerOnlyVisibility();
        updateCollageOnlyVisibility();

        if (mode === 'sticker') {
          openStep('templates');
          clearCollageFromCanvas();
        } else if (mode === 'collage') {
          openStep('layout');
          buildCollageSlots();
          renderCollageOnCanvas();
        } else {
          clearCollageFromCanvas();
        }
        updateStepCounter();

        // Mobile: se la scelta è avvenuta dentro il bottom sheet (tab Mode),
        // apri subito il sotto-step relativo, altrimenti chiudi lo sheet.
        var sheet = document.getElementById('cls-sheet');
        if (sheet && sheet.classList.contains('open')) {
          if (mode === 'sticker') { activateMobileTab('templates'); openMobileSheet('templates'); }
          else if (mode === 'collage') { activateMobileTab('layout'); openMobileSheet('layout'); }
          else { closeMobileSheet(); }
        }
      });
    });
    document.getElementById('cls-app').dataset.mode = state.mode;
    updateStickerOnlyVisibility();
    updateCollageOnlyVisibility();
  }

  function updateStickerOnlyVisibility() {
    var isSticker = state.mode === 'sticker';
    document.querySelectorAll('.cls-step--sticker-only, .cls-tab--sticker-only').forEach(function (el) {
      el.style.display = isSticker ? '' : 'none';
    });
  }

  function updateCollageOnlyVisibility() {
    var isCollage = state.mode === 'collage';
    document.querySelectorAll('.cls-step--collage-only, .cls-tab--collage-only').forEach(function (el) {
      el.style.display = isCollage ? '' : 'none';
    });
  }

  function clearCollageFromCanvas() {
    if (!printLayer) return;
    printLayer.find('.collageGroup').forEach(function (n) { n.destroy(); });
    printLayer.batchDraw();
  }

  /* ═══════════════════════════════════════════════════════
     BOTTOM BAR
     ═══════════════════════════════════════════════════════ */

  function updateHeaderInfo() {
    var modelName = slugToLabel(state.phoneModel || '');
    PHONE_GROUPS.forEach(function (g) {
      g.models.forEach(function (m) {
        if (m.id === state.phoneModel) modelName = m.name;
      });
    });

    var caseType = CASE_TYPES.find(function (ct) { return ct.id === state.caseType; });
    var caseColor = getColors();
    var el = document.getElementById('cls-header-model');
    if (el) el.textContent = modelName;
    var detail = document.getElementById('cls-header-detail');
    if (detail) {
      var parts = [];
      if (caseType) parts.push(caseType.name);
      if (caseColor) parts.push(caseColor.name);
      if (caseType && caseType.price) parts.push('<span id="cls-price-inline">' + caseType.price + '</span>');
      detail.innerHTML = parts.join(' · ');
    }
  }

  function getVisibleStepIds() {
    var ids = [];
    document.querySelectorAll('.cls-step').forEach(function (s) {
      if (s.style.display !== 'none') ids.push(s.dataset.step);
    });
    return ids;
  }

  function bindBottomBar() {
    document.getElementById('cls-next-step').addEventListener('click', function () {
      var ids = getVisibleStepIds();
      var cur = ids.indexOf(String(state.currentStep));
      if (cur < ids.length - 1) {
        openStep(ids[cur + 1]);
      }
    });

    document.getElementById('cls-prev-step').addEventListener('click', function () {
      var ids = getVisibleStepIds();
      var cur = ids.indexOf(String(state.currentStep));
      if (cur > 0) {
        openStep(ids[cur - 1]);
      }
    });

    document.getElementById('cls-clear').addEventListener('click', function () {
      if (!confirm('Remove all elements?')) return;
      saveUndo();
      var children = printLayer.getChildren();
      for (var i = children.length - 1; i >= 0; i--) {
        if (children[i].name() !== 'baseDesign') children[i].destroy();
      }
      stickerState._motifBgNode = null;
      stickerState.stickers = [];
      transformer.nodes([]);
      printLayer.batchDraw();
      uiLayer.batchDraw();
      updateStickerList();
      if (_layersPanelOpen) refreshLayersList();
    });

    document.getElementById('cls-undo').addEventListener('click', function () {
      toggleLayersPanel();
    });

    document.getElementById('cls-delete-selected').addEventListener('click', function () {
      var nodes = transformer.nodes();
      if (nodes.length) {
        saveUndo();
        nodes.forEach(function (n) { n.destroy(); });
        transformer.nodes([]);
        printLayer.batchDraw();
        uiLayer.batchDraw();
        this.style.display = 'none';
      }
    });
  }

  /* ═══════════════════════════════════════════════════════
     MOBILE TABS
     ═══════════════════════════════════════════════════════ */

  function bindMobileTabs() {
    document.querySelectorAll('.cls-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        // data-tab può essere numerico ("0".."6") o stringa ("base-design",
        // "templates", "layout"): NON usare parseInt (darebbe NaN sulle stringhe).
        var raw = tab.dataset.tab;
        var idx = /^\d+$/.test(raw) ? parseInt(raw, 10) : raw;
        activateMobileTab(idx);
        openMobileSheet(idx);
      });
    });
  }

  function activateMobileTab(idx) {
    document.querySelectorAll('.cls-tab').forEach(function (t) { t.classList.remove('active'); });
    var match = document.querySelector('.cls-tab[data-tab="' + idx + '"]');
    if (match) match.classList.add('active');
  }

  /* Bottom sheet mobile: spostiamo il body REALE dello step nello sheet (non un
     clone). Così id, listener e funzioni build esistenti restano validi e ogni
     step (Mode, Templates, Sticker, Upload, Collage, Base) funziona identico al
     desktop, senza dover ri-bindare nulla. Al ripristino il body torna al suo
     posto nella sidebar (nascosta su mobile). */
  var _sheetBody = null;
  var _sheetHome = null;

  function restoreSheetBody() {
    if (_sheetBody && _sheetHome && _sheetHome.parent) {
      // Ripristina gli stili dell'accordion (sovrascritti per lo sheet)
      _sheetBody.style.maxHeight = '';
      _sheetBody.style.overflow = '';
      _sheetBody.style.padding = '';
      if (_sheetHome.next && _sheetHome.next.parentNode === _sheetHome.parent) {
        _sheetHome.parent.insertBefore(_sheetBody, _sheetHome.next);
      } else {
        _sheetHome.parent.appendChild(_sheetBody);
      }
    }
    _sheetBody = null;
    _sheetHome = null;
  }

  function closeMobileSheet() {
    var sheet = document.getElementById('cls-sheet');
    if (sheet) sheet.classList.remove('open');
    restoreSheetBody();
  }

  function openMobileSheet(stepIdx) {
    var sheet = document.getElementById('cls-sheet');
    var content = document.getElementById('cls-sheet-content');
    var step = document.querySelector('.cls-step[data-step="' + stepIdx + '"]');
    var stepBody = step ? step.querySelector('.cls-step__body') : null;

    if (!stepBody) { sheet.classList.remove('open'); return; }

    // Riporta a casa il body precedente, poi sposta quello richiesto nello sheet.
    restoreSheetBody();
    _sheetBody = stepBody;
    _sheetHome = { parent: stepBody.parentNode, next: stepBody.nextSibling };
    // Override degli stili accordion (il body fuori da .cls-step.open sarebbe max-height:0)
    stepBody.style.maxHeight = 'none';
    stepBody.style.overflow = 'visible';
    stepBody.style.padding = '0';
    content.innerHTML = '';
    content.appendChild(stepBody);

    state.currentStep = stepIdx;
    updateStepCounter();
    sheet.classList.add('open');

    // Chiudi premendo handle o tappando fuori dallo sheet (backdrop)
    var handle = sheet.querySelector('.cls-sheet__handle');
    if (handle) {
      var newHandle = handle.cloneNode(true); // rimuove listener precedenti
      handle.parentNode.replaceChild(newHandle, handle);
      bindTap(newHandle, closeMobileSheet);
    }

    // Tap sul backdrop chiude il pannello. IMPORTANTE: usare un semplice 'click'
    // (NO touchend+preventDefault): un preventDefault sul touchend dello sheet
    // sopprimerebbe il click sintetico dei pulsanti interni → le scelte non si
    // confermerebbero su mobile. Legato una sola volta.
    if (!sheet._backdropBound) {
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet) closeMobileSheet();
      });
      sheet._backdropBound = true;
    }
  }

  /* Aggiunge click + touchend (per iOS) su un elemento clonato nel mobile sheet. */
  function bindTap(el, fn) {
    el.addEventListener('click', fn);
    el.addEventListener('touchend', function (e) {
      e.preventDefault();
      fn.call(el, e);
    }, { passive: false });
  }

  /* DEPRECATA / non più usata: il bottom sheet ora sposta il body REALE dello step
     (vedi openMobileSheet) invece di clonarlo, quindi i listener originali restano
     validi e non serve ri-bindare. Mantenuta solo come riferimento storico. */
  function rebindClonedEvents(container, stepIdx) {
    /* Step 0/1 — Modelli */
    if (stepIdx === 1 || stepIdx === 0) {
      container.querySelectorAll('.cls-model-btn').forEach(function (btn) {
        bindTap(btn, function () {
          state.phoneModel = btn.dataset.model;
          document.querySelectorAll('.cls-model-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          updateHeaderInfo();
          buildModelGroups();
          drawPhoneUnlessUsingApi();
          refreshBasePreservingDesign();
        });
      });
    }

    /* Step 2 — Tipo cover */
    if (stepIdx === 2) {
      container.querySelectorAll('.cls-casetype-btn').forEach(function (btn) {
        bindTap(btn, function () {
          state.caseType = btn.dataset.casetype;
          container.querySelectorAll('.cls-casetype-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          updateHeaderInfo();
          var firstColor = (CASE_COLORS[state.caseType] || [])[0];
          if (firstColor) state.caseColor = firstColor.id;
          buildColorSwatches();
          updateToughBaseVisibility();
          drawPhoneUnlessUsingApi();
          refreshBasePreservingDesign();
        });
      });
    }

    /* Step 3 — Colori */
    if (stepIdx === 3) {
      container.querySelectorAll('.cls-swatch').forEach(function (sw) {
        bindTap(sw, function () {
          state.caseColor = sw.dataset.color;
          container.querySelectorAll('.cls-swatch').forEach(function (s) { s.classList.remove('active'); });
          sw.classList.add('active');
          updateHeaderInfo();
          buildColorSwatches();
          drawPhoneUnlessUsingApi();
          refreshBasePreservingDesign();
        });
      });
    }

    /* Step 4 — Testo */
    if (stepIdx === 4) {
      var addBtn = container.querySelector('.cls-text-add-btn');
      var input = container.querySelector('.cls-text-input');
      if (addBtn && input) {
        bindTap(addBtn, function () { addTextToCanvas(input.value); });
      }
      container.querySelectorAll('.cls-font-btn').forEach(function (btn) {
        bindTap(btn, function () {
          state.selectedFont = btn.dataset.font;
          buildFontList();
          updateSelectedText({ fontFamily: btn.dataset.font });
        });
      });
      container.querySelectorAll('.cls-text-color').forEach(function (btn) {
        bindTap(btn, function () {
          if (btn.classList.contains('cls-text-color--picker')) return;
          state.selectedTextColor = btn.dataset.tcolor;
          buildTextColors();
          updateSelectedText({ fill: btn.dataset.tcolor });
        });
      });
      var picker = container.querySelector('.cls-text-color--picker input[type="color"]');
      var pickerWrap = container.querySelector('.cls-text-color--picker');
      if (picker && pickerWrap) {
        picker.addEventListener('input', function () {
          var hex = normalizeHexColor(picker.value);
          state.selectedTextColor = hex;
          state.selectedTextColorSlug = 'custom';
          container.querySelectorAll('.cls-text-color').forEach(function (b) { b.classList.remove('active'); });
          pickerWrap.classList.add('active');
          updateSelectedText({ fill: hex });
        });
      }
    }

    /* Step 5 — Upload */
    if (stepIdx === 5) {
      var uploadArea = container.querySelector('.cls-upload-area');
      var fileInput = container.querySelector('#cls-file-input');
      if (uploadArea && fileInput) {
        fileInput = fileInput.cloneNode(true);
        fileInput.removeAttribute('id');
        uploadArea.querySelector('input[type="file"]').replaceWith(fileInput);
        fileInput.addEventListener('change', handleFileUpload);
      }
    }

    /* Collage layout step — rebind layout buttons and slot file inputs */
    if (stepIdx === 'layout') {
      container.querySelectorAll('.cls-collage-layout-btn').forEach(function (btn) {
        bindTap(btn, function () {
          state.collageLayout = btn.dataset.layout;
          state.collagePhotos = {};
          collageImageCache = {};
          container.querySelectorAll('.cls-collage-layout-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          buildCollageLayoutPicker();
          buildCollageSlots();
          renderCollageOnCanvas();
        });
      });
      container.querySelectorAll('.cls-collage-slot').forEach(function (slot) {
        var idx = parseInt(slot.dataset.slotIdx, 10);
        var fi = slot.querySelector('input[type="file"]');
        if (fi) {
          var newFi = fi.cloneNode(true);
          fi.replaceWith(newFi);
          newFi.addEventListener('change', function () {
            handleCollageSlotFile(newFi, idx);
          });
          bindTap(slot.querySelector('.cls-collage-slot__inner'), function () { newFi.click(); });
        }
      });
    }

    /* Base design (tough case) — qualsiasi step */
    container.querySelectorAll('.cls-base-card').forEach(function (card) {
      bindTap(card, function () {
        var cod = card.dataset.codice;
        if (!cod) return;
        state.selectedBaseDesign = cod;
        container.querySelectorAll('.cls-base-card').forEach(function (c) { c.classList.remove('active'); });
        card.classList.add('active');
        applyAutoTextPaletteForToughBase(cod);
        refreshBasePreservingDesign();
      });
    });
  }

  /* ═══════════════════════════════════════════════════════
     TEXT TOOLS
     ═══════════════════════════════════════════════════════ */

  function bindTextTools() {
    document.getElementById('cls-text-add').addEventListener('click', function () {
      var input = document.getElementById('cls-text-input');
      addTextToCanvas(input.value);
    });

    document.getElementById('cls-text-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        addTextToCanvas(this.value);
      }
    });

    document.getElementById('cls-text-input').addEventListener('input', function () {
      state.customText = this.value;
    });

    document.getElementById('cls-text-size').addEventListener('input', function () {
      state.selectedTextSize = parseInt(this.value, 10);
      updateSelectedText({ fontSize: state.selectedTextSize * currentScale });
    });
  }

  function addTextToCanvas(text) {
    text = (text || '').trim();
    if (!text) return;

    state.customText = text;

    saveUndo();
    var b = printLayer._printBounds;
    if (!b) return;

    var kText = new Konva.Text({
      text: text,
      fontFamily: state.selectedFont,
      fontSize: state.selectedTextSize * currentScale,
      fill: state.selectedTextColor,
      x: b.x + b.w / 2,
      y: b.y + b.h / 2,
      offsetX: 0,
      offsetY: 0,
      align: 'center',
      draggable: true,
      name: 'userText'
    });
    kText.offsetX(kText.width() / 2);
    kText.offsetY(kText.height() / 2);

    kText.on('tap click', function () { selectNode(kText); });
    kText.on('dragend transformend', function () { saveUndo(); });
    kText.on('dblclick dbltap', function () { editTextInline(kText); });

    printLayer.add(kText);
    printLayer.batchDraw();
    selectNode(kText);
    document.getElementById('cls-text-input').value = '';
    
  }

  function editTextInline(node) {
    var newText = prompt('Edit text:', node.text());
    if (newText !== null && newText.trim()) {
      saveUndo();
      node.text(newText.trim());
      node.offsetX(node.width() / 2);
      node.offsetY(node.height() / 2);
      printLayer.batchDraw();
    }
  }

  function updateSelectedText(attrs) {
    var nodes = transformer.nodes();
    var requestedFamily = attrs && attrs.fontFamily ? attrs.fontFamily : null;

    function applyNow() {
      var hadSelection = nodes && nodes.length;
      if (attrs.fontFamily) {
        var appliedOnSelection = applyFontToNodes(nodes, attrs.fontFamily);
        if (!appliedOnSelection) {
          /* UX: se nessun testo è selezionato, applica il font a tutti i testi visibili. */
          applyFontToNodes(printLayer.find(function (node) { return node instanceof Konva.Text; }), attrs.fontFamily);
        }
      }
      if (attrs.fill || attrs.fontSize) {
        var target = hadSelection ? nodes : printLayer.find(function (node) { return node instanceof Konva.Text; });
        target.forEach(function (n) {
          if (!(n instanceof Konva.Text)) return;
          if (attrs.fill) n.fill(attrs.fill);
          if (attrs.fontSize) {
            n.fontSize(attrs.fontSize);
            n.offsetX(n.width() / 2);
            n.offsetY(n.height() / 2);
          }
        });
      }
      printLayer.batchDraw();
    }

    if (requestedFamily && document.fonts && document.fonts.load) {
      document.fonts.load('16px "' + requestedFamily + '"')
        .then(function () { applyNow(); })
        .catch(function () { applyNow(); });
      return;
    }
    applyNow();
  }

  function applyLayoutPreset(preset) {
    var nodes = transformer.nodes();
    var b = printLayer._printBounds;
    if (!b || !nodes.length) return;
    saveUndo();
    nodes.forEach(function (n) {
      n.x(b.x + b.w / 2);
      n.y(b.y + b.h * preset.yRatio);
      n.rotation(preset.rotation || 0);
      if (n instanceof Konva.Text) {
        n.offsetX(n.width() / 2);
        n.offsetY(n.height() / 2);
      }
    });
    printLayer.batchDraw();
  }

  /* ═══════════════════════════════════════════════════════
     UPLOAD & STICKERS
     ═══════════════════════════════════════════════════════ */

  function bindUploadTools() {
    var fileInput = document.getElementById('cls-file-input');
    var uploadArea = document.getElementById('cls-upload-area');

    fileInput.addEventListener('change', handleFileUpload);

    uploadArea.addEventListener('dragover', function (e) {
      e.preventDefault();
      uploadArea.classList.add('dragover');
    });
    uploadArea.addEventListener('dragleave', function () {
      uploadArea.classList.remove('dragover');
    });
    uploadArea.addEventListener('drop', function (e) {
      e.preventDefault();
      uploadArea.classList.remove('dragover');
      if (e.dataTransfer.files.length) {
        processFiles(e.dataTransfer.files);
      }
    });
  }

  function handleFileUpload(e) {
    if (!e.target.files || !e.target.files.length) return;

    if (state.mode === 'sticker') {
      var file = e.target.files[0];
      stickerState.currentPhoto = file;

      if (_activeTemplateTab === 'motifs') {
        var reader = new FileReader();
        reader.onload = function (ev) {
          stickerState._motifPhotoDataUrl = ev.target.result;
          var pImg = new Image();
          pImg.onload = function () {
            stickerState._motifPreviewImg = pImg;
            buildTemplateGrid();
            var tmpl = MOTIF_TEMPLATES.find(function (t) { return t.id === stickerState.selectedTemplate; });
            if (tmpl) {
              placeMotifPattern(tmpl, stickerState._motifPhotoDataUrl);
            }
          };
          pImg.src = ev.target.result;
        };
        reader.readAsDataURL(file);
        e.target.value = '';
        return;
      }

      if (_activeTemplateTab === 'frames') {
        var readerF = new FileReader();
        readerF.onload = function (ev) {
          stickerState._framePhotoDataUrl = ev.target.result;
          var fImg = new Image();
          fImg.onload = function () {
            stickerState._framePreviewImg = fImg;
            buildTemplateGrid();
            var ft = FRAME_TEMPLATES.find(function (t) { return t.id === stickerState.selectedTemplate; });
            if (ft) {
              placeFrameTemplate(ft, stickerState._framePhotoDataUrl);
            }
          };
          fImg.src = ev.target.result;
        };
        readerF.readAsDataURL(file);
        e.target.value = '';
        return;
      }

      openCropModal(file);
      e.target.value = '';
      return;
    }

    processFiles(e.target.files);
  }

  function processFiles(files) {
    Array.from(files).forEach(function (file) {
      if (!file.type.startsWith('image/')) return;
      if (file.size > 10 * 1024 * 1024) { alert('File too large (max 10MB)'); return; }

      var reader = new FileReader();
      reader.onload = function (e) {
        var dataUrl = e.target.result;
        addImageToCanvas(dataUrl);
        addUploadedThumb(dataUrl);
      };
      reader.readAsDataURL(file);
    });
  }

  function addImageToCanvas(dataUrl) {
    saveUndo();
    var img = new Image();
    img.onload = function () {
      var b = printLayer._printBounds;
      if (!b) return;
      var maxDim = Math.min(b.w, b.h) * 0.5;
      var scale = maxDim / Math.max(img.width, img.height);

      var kImg = new Konva.Image({
        image: img,
        x: b.x + b.w / 2,
        y: b.y + b.h / 2,
        width: img.width * scale,
        height: img.height * scale,
        offsetX: (img.width * scale) / 2,
        offsetY: (img.height * scale) / 2,
        draggable: true,
        name: 'userImage'
      });

      kImg.on('tap click', function () { selectNode(kImg); });
      kImg.on('dragend transformend', function () { saveUndo(); });

      printLayer.add(kImg);
      printLayer.batchDraw();
      selectNode(kImg);
      updateUploadCount();
    };
    img.src = dataUrl;
  }

  function addUploadedThumb(dataUrl) {
    var container = document.getElementById('cls-uploaded-list');
    var thumb = document.createElement('div');
    thumb.className = 'cls-uploaded-thumb';
    var img = document.createElement('img');
    img.src = dataUrl;
    thumb.appendChild(img);
    var removeBtn = document.createElement('button');
    removeBtn.className = 'cls-uploaded-thumb__remove';
    removeBtn.textContent = '×';
    removeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      thumb.remove();
      updateUploadCount();
    });
    thumb.appendChild(removeBtn);
    container.appendChild(thumb);
    updateUploadCount();
  }

  function updateUploadCount() {
    var count = document.querySelectorAll('.cls-uploaded-thumb').length;
    
  }

  /* ═══════════════════════════════════════════════════════
     AI BACKGROUND REMOVAL (remove.bg)
     ═══════════════════════════════════════════════════════ */

  function removeBgViaProxy(blob) {
    var fd = new FormData();
    fd.append('image', blob, 'sticker.png');

    return fetch(API_REMOVEBG, {
      method: 'POST',
      body: fd,
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.success) throw new Error(data.message || 'remove.bg error');
        return data.image;
      });
  }

  function removeBg(dataUrl, callback) {
    fetch(dataUrl)
      .then(function (r) { return r.blob(); })
      .then(function (blob) { return removeBgViaProxy(blob); })
      .then(function (resultDataUrl) { callback(resultDataUrl); })
      .catch(function (err) {
        console.error('removeBg failed:', err);
        callback(dataUrl);
      });
  }

  /* ═══════════════════════════════════════════════════════
     STICKER EFFECTS
     ═══════════════════════════════════════════════════════ */

  function bindEffects() {
    document.querySelectorAll('.cls-effect-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.cls-effect-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state.stickerEffect = btn.dataset.effect;
        applyEffectToSelected();
      });
    });
  }

  function applyEffectToSelected() {
    var nodes = transformer.nodes();
    nodes.forEach(function (n) {
      if (!(n instanceof Konva.Image)) return;
      n.shadowEnabled(false);
      n.strokeEnabled(false);

      switch (state.stickerEffect) {
        case 'border':
          n.stroke('#FFFFFF');
          n.strokeWidth(6);
          n.strokeEnabled(true);
          break;
        case 'shadow':
          n.shadowColor('#000');
          n.shadowBlur(15);
          n.shadowOffsetX(4);
          n.shadowOffsetY(4);
          n.shadowOpacity(0.4);
          n.shadowEnabled(true);
          break;
        case 'vintage':
          n.shadowColor('#8B7355');
          n.shadowBlur(8);
          n.shadowOpacity(0.3);
          n.shadowEnabled(true);
          break;
      }
    });
    printLayer.batchDraw();
  }

  /* ═══════════════════════════════════════════════════════
     SELECTION & UNDO
     ═══════════════════════════════════════════════════════ */

  function selectNode(node) {
    transformer.nodes([node]);
    uiLayer.batchDraw();
    document.getElementById('cls-delete-selected').style.display = '';
  }

  function saveUndo() {
    var json = printLayer.toJSON();
    state.undoStack.push(json);
    if (state.undoStack.length > 30) state.undoStack.shift();
  }

  function undo() {
    if (!state.undoStack.length) return;
    transformer.nodes([]);
    var json = state.undoStack.pop();
    var oldChildren = printLayer.getChildren().slice();
    oldChildren.forEach(function (c) { c.destroy(); });

    var parsed = JSON.parse(json);
    if (parsed.children) {
      parsed.children.forEach(function (childData) {
        var node = Konva.Node.create(childData);
        if (node.draggable()) {
          node.on('tap click', function () { selectNode(node); });
          node.on('dragend transformend', function () { saveUndo(); });
        }
        printLayer.add(node);
      });
    }
    printLayer.batchDraw();
    uiLayer.batchDraw();
  }

  /* ═══════════════════════════════════════════════════════
     EXPORT & ADD TO CART
     ═══════════════════════════════════════════════════════ */

  function bindCartButton() {
    document.getElementById('cls-add-to-cart').addEventListener('click', function () {
      exportAndAddToCart();
    });
  }

  function enableAddToCart() {
    document.getElementById('cls-add-to-cart').disabled = false;
  }

  function exportAndAddToCart() {
    var btn = document.getElementById('cls-add-to-cart');
    btn.disabled = true;
    btn.querySelector('.cls-header__cta-label').textContent = 'Saving...';

    transformer.nodes([]);
    uiLayer.batchDraw();

    var b = printLayer._printBounds;
    if (!b) { btn.disabled = false; return; }

    var dims = PHONE_DIMS[state.phoneModel] || PHONE_DIMS['default'];
    var exportScale = (dims.w || 710) / b.w;

    var dataUrl = printLayer.toDataURL({
      x: b.x, y: b.y,
      width: b.w, height: b.h,
      pixelRatio: exportScale
    });

    // Assicura che le varianti del prodotto dedicato siano caricate prima dell'upload
    loadStudioVariants().then(function () {
      var done = function (imageUrl) {
        if (!imageUrl) {
          alert('Upload failed. Please try again.');
          btn.disabled = false;
          btn.querySelector('.cls-header__cta-label').textContent = 'Add';
          return;
        }
        addToShopifyCart(imageUrl);
      };

      // Tough con base scelta → file di stampa = raw base + personalizzazioni (server-side).
      // Fallback all'upload del solo overlay se la composizione fallisce (es. raw non in cache).
      if (isToughCase() && state.selectedBaseDesign) {
        composePrintFile(dataUrl, function (printUrl) {
          if (printUrl) done(printUrl);
          else uploadToS3(dataUrl, done);
        });
      } else {
        uploadToS3(dataUrl, done);
      }
    });
  }

  /* Converte una URL S3 presigned (?X-Amz-...) in URL pubblica PERMANENTE quando
     l'oggetto è sotto un prefix già reso pubblico dalla bucket policy
     (renderproducts/*). Necessario perché la upload.php in produzione restituisce
     sempre un presigned a 7gg, ma l'oggetto è di fatto pubblico → la query è
     superflua e la URL "nuda" non scade (serve per stampare l'ordine in futuro). */
  function toPermanentS3Url(url) {
    if (!url) return url;
    try {
      var u = new URL(url, window.location.href);
      if (/coverlab-covers\.s3[.-]/.test(u.hostname) && /^\/renderproducts\//.test(u.pathname)) {
        return u.origin + u.pathname; // rimuove ?X-Amz-... → URL permanente
      }
    } catch (e) { /* lascia invariata */ }
    return url;
  }

  /* Tough: componi il file di stampa finale (raw base + overlay) lato server. */
  function composePrintFile(dataUrl, callback) {
    var endpoint = API_BASE + 'coverlab_studio_compose_print.php';
    var blob = dataURLtoBlob(dataUrl);
    var fd = new FormData();
    fd.append('overlay', blob, 'overlay_' + Date.now() + '.png');
    fd.append('codice_design', String(state.selectedBaseDesign || ''));
    fd.append('cmt_size', getApiSize(state.phoneModel));
    fetch(endpoint, { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (d) { callback(toPermanentS3Url((d && (d.url || d.s3_url)) || null)); })
      .catch(function () { callback(null); });
  }


  /* Carica le varianti del prodotto dedicato dal JSON storefront. */
  var _studioVariantsPromise = null;
  function loadStudioVariants() {
    if (_studioVariantsPromise) return _studioVariantsPromise;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root.replace(/\/$/, '') + '/products/' + STUDIO_PRODUCT_HANDLE + '.js';
    _studioVariantsPromise = fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        STUDIO_VARIANTS = p.variants.map(function (v) {
          return { id: v.id, sku: v.sku || '', available: v.available !== false };
        });
        STUDIO_VARIANT_BY_SKU = {};
        STUDIO_VARIANTS.forEach(function (v) {
          if (v.sku) STUDIO_VARIANT_BY_SKU[v.sku] = v.id;
        });
      })
      .catch(function () { /* fallback gestito da getVariantId */ });
    return _studioVariantsPromise;
  }

  function uploadToS3(dataUrl, callback) {
    var uploadEndpoint = document.querySelector('[data-upload-endpoint]');
    var endpoint = uploadEndpoint && uploadEndpoint.dataset.uploadEndpoint
      ? uploadEndpoint.dataset.uploadEndpoint
      : (API_BASE + 'coverlab_studio_upload.php');

    if (!endpoint) {
      callback(dataUrl);
      return;
    }

    var blob = dataURLtoBlob(dataUrl);
    var formData = new FormData();
    formData.append('image', blob, 'coverlab-custom-' + Date.now() + '.png');
    // Sotto renderproducts/* la bucket policy rende l'oggetto pubblico permanente.
    formData.append('folder', 'renderproducts/custom-studio');

    fetch(endpoint, { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function (data) { callback(toPermanentS3Url((data && (data.url || data.s3_url)) || null)); })
      .catch(function () { callback(null); });
  }

  function addToShopifyCart(imageUrl) {
    var btn = document.getElementById('cls-add-to-cart');
    var modelName = slugToLabel(state.phoneModel || '');
    PHONE_GROUPS.forEach(function (g) {
      g.models.forEach(function (m) {
        if (m.id === state.phoneModel) modelName = m.name;
      });
    });

    var caseType = CASE_TYPES.find(function (ct) { return ct.id === state.caseType; });
    var caseColor = getColors();
    var canvasJson = printLayer.toJSON();

    var productModel = caseType && caseType.product_model ? caseType.product_model : '';

    // Base grafica scelta (es. cover Tough). state.selectedBaseDesign è il codice_design,
    // identificatore univoco per la produzione (il "name" in DB è generico/non affidabile,
    // es. tante basi diverse si chiamano tutte "Black Pebbled").
    var baseCode = state.selectedBaseDesign ? String(state.selectedBaseDesign) : '';

    var properties = {
      'Phone Model': modelName,
      'Case Type': caseType ? caseType.name : state.caseType,
      'Case Color': caseColor ? caseColor.name : state.caseColor,
      'Text': state.customText || '',
      'Font': state.selectedFont || '',
      'Text Color': state.selectedTextColorSlug || '',
      'Layout': state.selectedLayoutId || '',
      // Link S3 permanente alla grafica stampabile (visibile, sopravvive all'evasione ordine)
      'Print File': imageUrl,
      // Attributi tecnici nascosti (prefisso _ → non mostrati a cliente, salvati nell'ordine)
      '_print_url': imageUrl,
      '_canvas_json': canvasJson,
      '_sku_model': state.phoneModel,
      '_sku_casetype': state.caseType,
      '_sku_product_model': productModel,
      '_sku_color': state.caseColor,
      '_studio_version': '1.1'
    };

    // Le Tough hanno colore unico ("Blank"): non mostrare "Case Color" nel carrello/ordine
    if (isToughCase()) {
      delete properties['Case Color'];
    }

    // Base grafica scelta: codice univoco di produzione (es. 277), visibile + nascosto.
    // Il raw della base è già compositato dentro "Print File" (server-side).
    if (baseCode) {
      properties['Base Design'] = baseCode;
      properties['_base_design_code'] = baseCode;
    }

    var variantId = getVariantId(productModel);
    if (!variantId || variantId === '0') {
      alert('Add to cart not available: missing product variant.');
      btn.disabled = false;
      btn.querySelector('.cls-header__cta-label').textContent = 'Add';
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: properties
      })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      window.location.href = '/cart';
    })
    .catch(function () {
      alert('Could not add to cart. Please try again.');
      btn.disabled = false;
      btn.querySelector('.cls-header__cta-label').textContent = 'Add';
    });
  }

  function getVariantId(productModel) {
    // 1) variante esplicita in query string (override manuale)
    var params = new URLSearchParams(window.location.search);
    var qp = params.get('variant') || params.get('variant_id');
    if (qp) return qp;

    // 2) variante del prodotto dedicato che corrisponde al tipo cover (SKU = product_model)
    var sku = STUDIO_SKU_ALIASES[productModel] || productModel;
    if (sku && STUDIO_VARIANT_BY_SKU[sku]) return String(STUDIO_VARIANT_BY_SKU[sku]);

    // 3) fallback: prima variante disponibile del prodotto dedicato
    var firstAvail = STUDIO_VARIANTS.find(function (v) { return v.available; }) || STUDIO_VARIANTS[0];
    if (firstAvail) return String(firstAvail.id);

    return '0';
  }

  /* ═══════════════════════════════════════════════════════
     UTILITIES
     ═══════════════════════════════════════════════════════ */

  function debounce(fn, ms) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, ms);
    };
  }

  function dataURLtoBlob(dataUrl) {
    var parts = dataUrl.split(',');
    var mime = parts[0].match(/:(.*?);/)[1];
    var raw = atob(parts[1]);
    var arr = new Uint8Array(raw.length);
    for (var i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
    return new Blob([arr], { type: mime });
  }

  /* ═══════════════════════════════════════════════════════
     STICKER STUDIO — Templates, Crop, AI, Modify
     ═══════════════════════════════════════════════════════ */

  var CUTOUT_TEMPLATES = [
    {
      id: 'scatter-6',
      name: 'Scatter',
      slots: [
        { xR: 0.20, yR: 0.12, scale: 0.38, rot: -15 },
        { xR: 0.70, yR: 0.08, scale: 0.32, rot: 10 },
        { xR: 0.15, yR: 0.38, scale: 0.35, rot: 5 },
        { xR: 0.72, yR: 0.35, scale: 0.40, rot: -8 },
        { xR: 0.25, yR: 0.62, scale: 0.33, rot: 12 },
        { xR: 0.68, yR: 0.65, scale: 0.36, rot: -10 },
        { xR: 0.45, yR: 0.88, scale: 0.30, rot: 5 }
      ]
    },
    {
      id: 'grid-9',
      name: 'Grid',
      slots: [
        { xR: 0.18, yR: 0.10, scale: 0.28, rot: 0 },
        { xR: 0.50, yR: 0.10, scale: 0.28, rot: 0 },
        { xR: 0.82, yR: 0.10, scale: 0.28, rot: 0 },
        { xR: 0.18, yR: 0.38, scale: 0.28, rot: 0 },
        { xR: 0.50, yR: 0.38, scale: 0.28, rot: 0 },
        { xR: 0.82, yR: 0.38, scale: 0.28, rot: 0 },
        { xR: 0.18, yR: 0.66, scale: 0.28, rot: 0 },
        { xR: 0.50, yR: 0.66, scale: 0.28, rot: 0 },
        { xR: 0.82, yR: 0.66, scale: 0.28, rot: 0 }
      ]
    },
    {
      id: 'diagonal-5',
      name: 'Diagonal',
      slots: [
        { xR: 0.15, yR: 0.08, scale: 0.35, rot: -20 },
        { xR: 0.55, yR: 0.22, scale: 0.38, rot: -20 },
        { xR: 0.25, yR: 0.42, scale: 0.35, rot: -20 },
        { xR: 0.65, yR: 0.55, scale: 0.38, rot: -20 },
        { xR: 0.35, yR: 0.75, scale: 0.35, rot: -20 }
      ]
    },
    {
      id: 'big-center',
      name: 'Big Center',
      slots: [
        { xR: 0.50, yR: 0.45, scale: 0.70, rot: 0 }
      ]
    },
    {
      id: 'repeat-tile',
      name: 'Repeat',
      slots: (function () {
        var s = [];
        for (var row = 0; row < 5; row++) {
          for (var col = 0; col < 3; col++) {
            var offset = (row % 2 === 1) ? 0.12 : 0;
            s.push({
              xR: 0.18 + col * 0.30 + offset,
              yR: 0.06 + row * 0.19,
              scale: 0.24,
              rot: 0
            });
          }
        }
        return s;
      })()
    },
    {
      id: 'cascade',
      name: 'Cascade',
      slots: [
        { xR: 0.50, yR: 0.08, scale: 0.44, rot: -5 },
        { xR: 0.35, yR: 0.30, scale: 0.38, rot: 8 },
        { xR: 0.60, yR: 0.48, scale: 0.42, rot: -3 },
        { xR: 0.40, yR: 0.70, scale: 0.36, rot: 6 },
        { xR: 0.55, yR: 0.90, scale: 0.34, rot: -8 }
      ]
    }
  ];

  /* ═══════════════════════════════════════════════════════
     MOTIF TEMPLATES — decorative patterns over user photo
     ═══════════════════════════════════════════════════════ */

  var MOTIF_TEMPLATES = [
    {
      id: 'motif-stars',
      name: 'Stars',
      shape: 'star',
      color: '#1a1a1a',
      items: [
        { xR: 0.15, yR: 0.06, size: 0.18, rot: 10 },
        { xR: 0.72, yR: 0.04, size: 0.14, rot: -15 },
        { xR: 0.88, yR: 0.15, size: 0.20, rot: 5 },
        { xR: 0.08, yR: 0.28, size: 0.22, rot: -8 },
        { xR: 0.55, yR: 0.22, size: 0.16, rot: 20 },
        { xR: 0.85, yR: 0.38, size: 0.18, rot: -12 },
        { xR: 0.20, yR: 0.50, size: 0.20, rot: 15 },
        { xR: 0.70, yR: 0.52, size: 0.22, rot: -5 },
        { xR: 0.10, yR: 0.72, size: 0.16, rot: 8 },
        { xR: 0.50, yR: 0.68, size: 0.14, rot: -18 },
        { xR: 0.82, yR: 0.70, size: 0.20, rot: 3 },
        { xR: 0.35, yR: 0.88, size: 0.18, rot: -10 },
        { xR: 0.75, yR: 0.90, size: 0.16, rot: 12 }
      ]
    },
    {
      id: 'motif-flowers',
      name: 'Flowers',
      shape: 'flower',
      color: '#ffffff',
      items: [
        { xR: 0.18, yR: 0.05, size: 0.22, rot: 0 },
        { xR: 0.70, yR: 0.02, size: 0.18, rot: 30 },
        { xR: 0.90, yR: 0.20, size: 0.20, rot: 15 },
        { xR: 0.05, yR: 0.30, size: 0.24, rot: -20 },
        { xR: 0.50, yR: 0.25, size: 0.16, rot: 10 },
        { xR: 0.80, yR: 0.42, size: 0.22, rot: -10 },
        { xR: 0.22, yR: 0.55, size: 0.20, rot: 25 },
        { xR: 0.65, yR: 0.58, size: 0.18, rot: -5 },
        { xR: 0.10, yR: 0.75, size: 0.22, rot: 0 },
        { xR: 0.50, yR: 0.72, size: 0.16, rot: 15 },
        { xR: 0.85, yR: 0.78, size: 0.20, rot: -15 },
        { xR: 0.35, yR: 0.92, size: 0.18, rot: 10 }
      ]
    },
    {
      id: 'motif-polka',
      name: 'Polka Dots',
      shape: 'circle',
      color: '#1a1a1a',
      items: (function () {
        var dots = [];
        for (var row = 0; row < 8; row++) {
          for (var col = 0; col < 4; col++) {
            var offset = (row % 2 === 1) ? 0.12 : 0;
            dots.push({
              xR: 0.12 + col * 0.24 + offset,
              yR: 0.04 + row * 0.13,
              size: 0.06,
              rot: 0
            });
          }
        }
        return dots;
      })()
    },
    {
      id: 'motif-hearts',
      name: 'Hearts',
      shape: 'heart',
      color: '#e74c6f',
      items: [
        { xR: 0.20, yR: 0.08, size: 0.16, rot: -10 },
        { xR: 0.75, yR: 0.05, size: 0.14, rot: 12 },
        { xR: 0.10, yR: 0.30, size: 0.18, rot: 5 },
        { xR: 0.55, yR: 0.25, size: 0.12, rot: -8 },
        { xR: 0.85, yR: 0.35, size: 0.16, rot: 15 },
        { xR: 0.30, yR: 0.50, size: 0.20, rot: -5 },
        { xR: 0.70, yR: 0.55, size: 0.14, rot: 10 },
        { xR: 0.15, yR: 0.70, size: 0.16, rot: -12 },
        { xR: 0.50, yR: 0.72, size: 0.18, rot: 8 },
        { xR: 0.80, yR: 0.75, size: 0.14, rot: -15 },
        { xR: 0.35, yR: 0.90, size: 0.16, rot: 5 }
      ]
    },
    {
      id: 'motif-stars-outline',
      name: 'Stars Outline',
      shape: 'star',
      color: '#ffffff',
      strokeOnly: true,
      strokeWidth: 3,
      items: [
        { xR: 0.12, yR: 0.08, size: 0.20, rot: 0 },
        { xR: 0.65, yR: 0.05, size: 0.16, rot: 15 },
        { xR: 0.88, yR: 0.22, size: 0.22, rot: -10 },
        { xR: 0.10, yR: 0.35, size: 0.18, rot: 8 },
        { xR: 0.50, yR: 0.30, size: 0.14, rot: -20 },
        { xR: 0.80, yR: 0.50, size: 0.20, rot: 5 },
        { xR: 0.25, yR: 0.55, size: 0.22, rot: -5 },
        { xR: 0.65, yR: 0.62, size: 0.16, rot: 12 },
        { xR: 0.15, yR: 0.78, size: 0.18, rot: -8 },
        { xR: 0.50, yR: 0.80, size: 0.20, rot: 0 },
        { xR: 0.82, yR: 0.85, size: 0.16, rot: 10 }
      ]
    }
  ];

  /* ═══════════════════════════════════════════════════════
     FRAME TEMPLATES — foto visibile solo nella “finestra” + bordo sopra
     ═══════════════════════════════════════════════════════ */

  /** Se true, area stampa fuori dal buco è colorata/pattern (stile “poster”); default false = trasparente (si vede la cover). */
  function frameHasOpaqueOutside(tmpl) {
    return tmpl.opaqueOutside === true && !!(tmpl.bgColor || (tmpl.bgPattern && tmpl.bgPattern !== 'none'));
  }

  var _frameHoleHitCanvas = null;

  function isPointInFrameHole(px, py, tmpl, cx, cy, holeR, rx, ry) {
    if (tmpl.shape === 'ellipse') {
      if (rx <= 0 || ry <= 0) return false;
      var nx = (px - cx) / rx;
      var ny = (py - cy) / ry;
      return nx * nx + ny * ny <= 1.002;
    }
    if (!_frameHoleHitCanvas) {
      _frameHoleHitCanvas = document.createElement('canvas');
      _frameHoleHitCanvas.width = 8;
      _frameHoleHitCanvas.height = 8;
    }
    var htx = _frameHoleHitCanvas.getContext('2d');
    htx.setTransform(1, 0, 0, 1, 0, 0);
    htx.beginPath();
    appendHeartPath2d(htx, cx, cy, holeR);
    return htx.isPointInPath(px, py);
  }

  /**
   * Cuoricini / pallini solo fuori dal buco della foto (stesso coordinate area stampa).
   * Ritorna canvas o null.
   */
  function buildFrameOutsideDecorCanvas(tmpl, bw, bh, cx, cy, holeR, rx, ry) {
    var mode = tmpl.outsideDecor;
    if (!mode || mode === 'none') return null;

    var w = Math.max(1, Math.ceil(bw));
    var h = Math.max(1, Math.ceil(bh));
    var c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    var ctx = c.getContext('2d');

    var minS = Math.min(bw, bh);
    var areaRatio = (bw * bh) / (280 * 460);
    var count = Math.round((tmpl.outsideDecorCount != null ? tmpl.outsideDecorCount : 52) * Math.max(0.65, Math.min(1.35, areaRatio)));
    count = Math.max(20, Math.min(95, count));

    var col = tmpl.outsideDecorColor || '#e91e63';
    var alphaBase = tmpl.outsideDecorAlpha != null ? tmpl.outsideDecorAlpha : 0.52;
    var baseDot = minS * 0.011;
    var baseHeart = minS * 0.02;

    var placed = 0;
    var attempts = 0;
    var maxAttempts = count * 30;

    while (placed < count && attempts < maxAttempts) {
      attempts++;
      var px = Math.random() * bw;
      var py = Math.random() * bh;
      if (isPointInFrameHole(px, py, tmpl, cx, cy, holeR, rx, ry)) continue;

      var kind = mode;
      if (mode === 'mixed') kind = Math.random() < 0.55 ? 'hearts' : 'dots';

      ctx.save();
      ctx.globalAlpha = alphaBase * (0.45 + Math.random() * 0.55);

      if (kind === 'dots') {
        var rr = baseDot * (0.55 + Math.random() * 1.1);
        ctx.beginPath();
        ctx.arc(px, py, rr, 0, Math.PI * 2);
        ctx.fillStyle = col;
        ctx.fill();
      } else {
        var hr = baseHeart * (0.5 + Math.random() * 0.85);
        ctx.translate(px, py);
        ctx.fillStyle = col;
        drawHeartPath(ctx, 0, 0, hr);
        ctx.fill();
      }
      ctx.restore();
      placed++;
    }

    return c;
  }

  function drawFrameOutsideDecorPreview(ctx, w, h, tmpl, cx, cy, holeR, rx, ry) {
    var c = buildFrameOutsideDecorCanvas(tmpl, w, h, cx, cy, holeR, rx, ry);
    if (c) ctx.drawImage(c, 0, 0);
  }

  var FRAME_TEMPLATES = [
    {
      id: 'frame-heart-sweet',
      name: 'Sweet Heart',
      shape: 'heart',
      center: { xR: 0.5, yR: 0.46 },
      holeR: 0.34,
      borderColor: '#c62828',
      borderWidthR: 0.038,
      outsideDecor: 'hearts',
      outsideDecorColor: '#ec407a',
      outsideDecorAlpha: 0.5
    },
    {
      id: 'frame-heart-neon',
      name: 'Neon Heart',
      shape: 'heart',
      center: { xR: 0.5, yR: 0.44 },
      holeR: 0.32,
      borderColor: '#ff2d95',
      borderWidthR: 0.032,
      outsideDecor: 'dots',
      outsideDecorColor: '#ff2d95',
      outsideDecorAlpha: 0.42
    },
    {
      id: 'frame-oval-soft',
      name: 'Soft Oval',
      shape: 'ellipse',
      center: { xR: 0.5, yR: 0.45 },
      radiusXR: 0.36,
      radiusYR: 0.46,
      borderColor: '#5d4037',
      borderWidthR: 0.028,
      outsideDecor: 'mixed',
      outsideDecorColor: '#8d6e63',
      outsideDecorAlpha: 0.48
    }
  ];

  var _activeTemplateTab = 'cutouts';

  var stickerState = {
    selectedTemplate: null,
    currentPhoto: null,
    cropRect: { x: 0, y: 0, w: 1, h: 1 },
    croppedBlob: null,
    processedBlob: null,
    processedDataUrl: null,
    outlineEnabled: true,
    outlineSmooth: 3,
    outlineWidth: 6,
    stickers: [],
    _motifPhotoDataUrl: null,
    _motifPreviewImg: null,
    _motifBgNode: null,
    _framePhotoDataUrl: null,
    _framePreviewImg: null
  };

  function buildTemplateGrid() {
    var grid = document.getElementById('cls-template-grid');
    if (!grid) return;
    grid.innerHTML = '';
    grid.classList.remove('cls-template-grid--motifs');
    if (_activeTemplateTab === 'motifs' || _activeTemplateTab === 'frames') {
      grid.classList.add('cls-template-grid--motifs');
    }

    var templates = CUTOUT_TEMPLATES;
    if (_activeTemplateTab === 'motifs') templates = MOTIF_TEMPLATES;
    else if (_activeTemplateTab === 'frames') templates = FRAME_TEMPLATES;

    templates.forEach(function (tmpl) {
      var card = document.createElement('div');
      card.className = 'cls-template-card' + (stickerState.selectedTemplate === tmpl.id ? ' active' : '');
      card.dataset.templateId = tmpl.id;

      var preview = document.createElement('canvas');
      preview.width = 120; preview.height = 200;

      if (_activeTemplateTab === 'motifs') {
        drawMotifPreview(preview, tmpl);
      } else if (_activeTemplateTab === 'frames') {
        drawFramePreview(preview, tmpl);
      } else {
        preview.height = 120;
        drawTemplatePreview(preview, tmpl);
      }
      card.appendChild(preview);

      var label = document.createElement('span');
      label.className = 'cls-template-card__label';
      label.textContent = tmpl.name;
      card.appendChild(label);

      card.addEventListener('click', function () {
        stickerState.selectedTemplate = tmpl.id;
        grid.querySelectorAll('.cls-template-card').forEach(function (c) { c.classList.remove('active'); });
        card.classList.add('active');
        if (_activeTemplateTab === 'motifs') {
          applyMotifTemplate(tmpl);
        } else if (_activeTemplateTab === 'frames') {
          applyFrameTemplate(tmpl);
        } else {
          applyStickerTemplate(tmpl);
        }
      });

      grid.appendChild(card);
    });
  }

  function drawTemplatePreview(canvas, tmpl) {
    var ctx = canvas.getContext('2d');
    var w = canvas.width, h = canvas.height;
    ctx.fillStyle = '#fafafa';
    ctx.fillRect(0, 0, w, h);

    ctx.fillStyle = '#e0d5c8';
    tmpl.slots.forEach(function (slot) {
      var sz = w * slot.scale * 0.45;
      ctx.save();
      ctx.translate(slot.xR * w, slot.yR * h);
      ctx.rotate((slot.rot || 0) * Math.PI / 180);
      ctx.beginPath();
      ctx.arc(0, 0, sz / 2, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    });
  }

  function drawMotifPreview(canvas, tmpl) {
    var ctx = canvas.getContext('2d');
    var w = canvas.width, h = canvas.height;
    var r = 12;

    ctx.fillStyle = '#f0eeeb';
    ctx.beginPath();
    ctx.moveTo(r, 0); ctx.lineTo(w - r, 0);
    ctx.arcTo(w, 0, w, r, r); ctx.lineTo(w, h - r);
    ctx.arcTo(w, h, w - r, h, r); ctx.lineTo(r, h);
    ctx.arcTo(0, h, 0, h - r, r); ctx.lineTo(0, r);
    ctx.arcTo(0, 0, r, 0, r); ctx.closePath();
    ctx.fill();

    if (stickerState.currentPhoto && stickerState._motifPreviewImg) {
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(r, 0); ctx.lineTo(w - r, 0);
      ctx.arcTo(w, 0, w, r, r); ctx.lineTo(w, h - r);
      ctx.arcTo(w, h, w - r, h, r); ctx.lineTo(r, h);
      ctx.arcTo(0, h, 0, h - r, r); ctx.lineTo(0, r);
      ctx.arcTo(0, 0, r, 0, r); ctx.closePath();
      ctx.clip();
      var pImg = stickerState._motifPreviewImg;
      var imgAspect = pImg.width / pImg.height;
      var canvasAspect = w / h;
      var dw, dh, dx, dy;
      if (imgAspect > canvasAspect) {
        dh = h; dw = h * imgAspect; dx = (w - dw) / 2; dy = 0;
      } else {
        dw = w; dh = w / imgAspect; dx = 0; dy = (h - dh) / 2;
      }
      ctx.globalAlpha = 0.4;
      ctx.drawImage(pImg, dx, dy, dw, dh);
      ctx.globalAlpha = 1;
      ctx.restore();
    }

    tmpl.items.forEach(function (item) {
      var sz = w * item.size;
      ctx.save();
      ctx.translate(item.xR * w, item.yR * h);
      ctx.rotate((item.rot || 0) * Math.PI / 180);

      if (tmpl.shape === 'star') {
        drawStarPath(ctx, 0, 0, sz / 2, tmpl.strokeOnly);
      } else if (tmpl.shape === 'flower') {
        drawFlowerPath(ctx, 0, 0, sz / 2);
      } else if (tmpl.shape === 'heart') {
        drawHeartPath(ctx, 0, 0, sz / 2);
      } else {
        ctx.beginPath();
        ctx.arc(0, 0, sz / 2, 0, Math.PI * 2);
      }

      if (tmpl.strokeOnly) {
        ctx.strokeStyle = tmpl.color;
        ctx.lineWidth = tmpl.strokeWidth || 2;
        ctx.stroke();
      } else {
        ctx.fillStyle = tmpl.color;
        ctx.fill();
      }
      ctx.restore();
    });
  }

  function drawStarPath(ctx, cx, cy, r) {
    var spikes = 5, outerR = r, innerR = r * 0.45;
    ctx.beginPath();
    for (var i = 0; i < spikes * 2; i++) {
      var rad = (i * Math.PI / spikes) - Math.PI / 2;
      var rr = (i % 2 === 0) ? outerR : innerR;
      var x = cx + Math.cos(rad) * rr;
      var y = cy + Math.sin(rad) * rr;
      if (i === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    }
    ctx.closePath();
  }

  function drawFlowerPath(ctx, cx, cy, r) {
    var petals = 5, petalR = r * 0.55;
    ctx.beginPath();
    for (var i = 0; i < petals; i++) {
      var angle = (i / petals) * Math.PI * 2 - Math.PI / 2;
      var px = cx + Math.cos(angle) * r * 0.45;
      var py = cy + Math.sin(angle) * r * 0.45;
      ctx.moveTo(px + petalR, py);
      ctx.arc(px, py, petalR, 0, Math.PI * 2);
    }
    ctx.moveTo(cx + r * 0.22, cy);
    ctx.arc(cx, cy, r * 0.22, 0, Math.PI * 2);
  }

  function drawHeartPath(ctx, cx, cy, r) {
    var w = r, h = r;
    ctx.beginPath();
    appendHeartPath2d(ctx, cx, cy, r);
  }

  /** Traccia il cuore (path unico) per clip e anteprime. `ctx` può essere 2d o Konva.SceneContext. */
  function appendHeartPath2d(ctx, cx, cy, r) {
    var w = r, h = r;
    ctx.moveTo(cx, cy + h * 0.35);
    ctx.bezierCurveTo(cx, cy - h * 0.2, cx - w, cy - h * 0.2, cx - w, cy + h * 0.05);
    ctx.bezierCurveTo(cx - w, cy + h * 0.35, cx, cy + h * 0.6, cx, cy + h * 0.8);
    ctx.bezierCurveTo(cx, cy + h * 0.6, cx + w, cy + h * 0.35, cx + w, cy + h * 0.05);
    ctx.bezierCurveTo(cx + w, cy - h * 0.2, cx, cy - h * 0.2, cx, cy + h * 0.35);
    ctx.closePath();
  }

  function drawFrameBgPattern(ctx, w, h, tmpl) {
    if (!tmpl.bgPattern || tmpl.bgPattern === 'none') return;
    var m = Math.min(w, h);
    if (tmpl.bgPattern === 'mini-hearts') {
      var col = tmpl.patternColor || '#ffb6c1';
      var step = Math.max(18, m * 0.07);
      for (var px = step * 0.5; px < w; px += step) {
        for (var py = step * 0.5; py < h; py += step) {
          ctx.save();
          ctx.fillStyle = col;
          ctx.translate(px, py);
          ctx.scale(0.22, 0.22);
          drawHeartPath(ctx, 0, 0, 14);
          ctx.fill();
          ctx.restore();
        }
      }
    } else if (tmpl.bgPattern === 'dots') {
      ctx.fillStyle = tmpl.patternColor || 'rgba(255,255,255,0.2)';
      for (var x = 0; x < w; x += 12) {
        for (var y = 0; y < h; y += 12) {
          if ((x + y) % 24 === 0) {
            ctx.beginPath();
            ctx.arc(x + 2, y + 2, 1.8, 0, Math.PI * 2);
            ctx.fill();
          }
        }
      }
    }
  }

  function drawFramePreview(canvas, tmpl) {
    var ctx = canvas.getContext('2d');
    var w = canvas.width, h = canvas.height;
    var r = 12;
    var cx = tmpl.center.xR * w;
    var cy = tmpl.center.yR * h;
    var minS = Math.min(w, h);
    var holeR = (tmpl.holeR || 0.32) * minS;

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(r, 0); ctx.lineTo(w - r, 0);
    ctx.arcTo(w, 0, w, r, r); ctx.lineTo(w, h - r);
    ctx.arcTo(w, h, w - r, h, r); ctx.lineTo(r, h);
    ctx.arcTo(0, h, 0, h - r, r); ctx.lineTo(0, r);
    ctx.arcTo(0, 0, r, 0, r); ctx.closePath();
    ctx.clip();

    if (frameHasOpaqueOutside(tmpl)) {
      ctx.fillStyle = tmpl.bgColor || '#f5f5f5';
      ctx.fillRect(0, 0, w, h);
      drawFrameBgPattern(ctx, w, h, tmpl);
    } else {
      var gs = 7;
      for (var gx = 0; gx < w + gs; gx += gs) {
        for (var gy = 0; gy < h + gs; gy += gs) {
          ctx.fillStyle = ((Math.floor(gx / gs) + Math.floor(gy / gs)) % 2) ? '#e4e4e4' : '#fff';
          ctx.fillRect(gx, gy, gs, gs);
        }
      }
    }

    var rxPrev = (tmpl.radiusXR || 0.36) * w;
    var ryPrev = (tmpl.radiusYR || 0.46) * h;
    drawFrameOutsideDecorPreview(ctx, w, h, tmpl, cx, cy, holeR, rxPrev, ryPrev);

    if (stickerState._framePreviewImg) {
      ctx.save();
      ctx.beginPath();
      if (tmpl.shape === 'ellipse') {
        var rx = rxPrev;
        var ry = ryPrev;
        ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
      } else {
        appendHeartPath2d(ctx, cx, cy, holeR);
      }
      ctx.clip();
      var pImg = stickerState._framePreviewImg;
      var imgAspect = pImg.width / pImg.height;
      var cw = w, ch = h;
      var ca = cw / ch;
      var dw, dh, dx, dy;
      if (imgAspect > ca) {
        dh = ch; dw = ch * imgAspect; dx = (cw - dw) / 2; dy = 0;
      } else {
        dw = cw; dh = cw / imgAspect; dx = 0; dy = (ch - dh) / 2;
      }
      ctx.globalAlpha = 0.9;
      ctx.drawImage(pImg, dx, dy, dw, dh);
      ctx.globalAlpha = 1;
      ctx.restore();
    }

    ctx.restore();

    ctx.save();
    ctx.lineJoin = 'round';
    ctx.strokeStyle = tmpl.borderColor || '#c62828';
    ctx.lineWidth = Math.max(2, (tmpl.borderWidthR || 0.035) * minS * (w / 120));
    ctx.beginPath();
    if (tmpl.shape === 'ellipse') {
      var rx2 = (tmpl.radiusXR || 0.36) * w;
      var ry2 = (tmpl.radiusYR || 0.46) * h;
      ctx.ellipse(cx, cy, rx2, ry2, 0, 0, Math.PI * 2);
    } else {
      appendHeartPath2d(ctx, cx, cy, holeR);
    }
    ctx.stroke();
    ctx.restore();
  }

  function applyFrameTemplate(tmpl) {
    clearStickerNodes();
    clearMotifBackground();
    if (stickerState._framePhotoDataUrl) {
      placeFrameTemplate(tmpl, stickerState._framePhotoDataUrl);
    }
  }

  function placeFrameTemplate(tmpl, photoDataUrl) {
    var b = printLayer._printBounds;
    if (!b) return;

    var img = new Image();
    img.onload = function () {
      clearStickerNodes();
      clearMotifBackground();

      var bw = b.w, bh = b.h;
      var minSide = Math.min(bw, bh);
      var cx = tmpl.center.xR * bw;
      var cy = tmpl.center.yR * bh;
      var holeR = (tmpl.holeR || 0.32) * minSide;
      var borderW = Math.max(2, (tmpl.borderWidthR || 0.035) * minSide);
      var rx = (tmpl.radiusXR || 0.38) * bw;
      var ry = (tmpl.radiusYR || 0.46) * bh;

      var frameRoot = new Konva.Group({
        x: b.x,
        y: b.y,
        draggable: true,
        name: 'frame-root'
      });
      frameRoot.on('tap click', function () { selectNode(frameRoot); });
      frameRoot.on('dragend transformend', function () { printLayer.batchDraw(); });

      if (frameHasOpaqueOutside(tmpl)) {
        if (tmpl.bgPattern && tmpl.bgPattern !== 'none') {
          var bgCanv = document.createElement('canvas');
          bgCanv.width = Math.max(1, Math.ceil(bw));
          bgCanv.height = Math.max(1, Math.ceil(bh));
          var bgCtx = bgCanv.getContext('2d');
          bgCtx.fillStyle = tmpl.bgColor || '#f5f0f0';
          bgCtx.fillRect(0, 0, bgCanv.width, bgCanv.height);
          drawFrameBgPattern(bgCtx, bgCanv.width, bgCanv.height, tmpl);
          frameRoot.add(new Konva.Image({
            image: bgCanv,
            x: 0, y: 0,
            width: bw, height: bh,
            listening: false
          }));
        } else if (tmpl.bgColor) {
          frameRoot.add(new Konva.Rect({
            x: 0, y: 0,
            width: bw, height: bh,
            fill: tmpl.bgColor,
            listening: false
          }));
        }
      }

      var decorCanv = buildFrameOutsideDecorCanvas(tmpl, bw, bh, cx, cy, holeR, rx, ry);
      if (decorCanv) {
        frameRoot.add(new Konva.Image({
          image: decorCanv,
          x: 0, y: 0,
          width: bw,
          height: bh,
          listening: false,
          name: 'frame-decor'
        }));
      }

      var clipGroup = new Konva.Group({
        clipFunc: function (ctx) {
          ctx.beginPath();
          if (tmpl.shape === 'ellipse') {
            ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
          } else {
            appendHeartPath2d(ctx, cx, cy, holeR);
          }
        }
      });

      var imgAspect = img.width / img.height;
      var boxAspect = bw / bh;
      var dw, dh, dx, dy;
      if (imgAspect > boxAspect) {
        dh = bh; dw = bh * imgAspect;
        dx = (bw - dw) / 2; dy = 0;
      } else {
        dw = bw; dh = bw / imgAspect;
        dx = 0; dy = (bh - dh) / 2;
      }

      var photoNode = new Konva.Image({
        image: img,
        x: dx, y: dy,
        width: dw, height: dh,
        draggable: true,
        name: 'frame-photo'
      });
      photoNode.on('tap click', function (e) {
        e.cancelBubble = true;
        selectNode(photoNode);
      });
      photoNode.on('dragend transformend', function () { printLayer.batchDraw(); });

      clipGroup.add(photoNode);
      frameRoot.add(clipGroup);

      var borderShape = new Konva.Shape({
        stroke: tmpl.borderColor || '#c62828',
        strokeWidth: borderW,
        lineJoin: 'round',
        listening: false,
        name: 'frame-border',
        sceneFunc: function (context, shape) {
          context.beginPath();
          if (tmpl.shape === 'ellipse') {
            context.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
          } else {
            appendHeartPath2d(context, cx, cy, holeR);
          }
          context.closePath();
          context.strokeShape(shape);
        }
      });
      frameRoot.add(borderShape);

      printLayer.add(frameRoot);
      transformer.nodes([]);
      printLayer.batchDraw();
    };
    img.src = photoDataUrl;
  }

  function applyStickerTemplate(tmpl) {
    clearStickerNodes();
    if (!stickerState.processedDataUrl) return;
    placeStickersFromTemplate(tmpl, stickerState.processedDataUrl);
  }

  function applyMotifTemplate(tmpl) {
    clearStickerNodes();
    clearMotifBackground();
    if (stickerState._motifPhotoDataUrl) {
      placeMotifPattern(tmpl, stickerState._motifPhotoDataUrl);
    }
  }

  function clearStickerNodes() {
    if (!printLayer) return;
    printLayer.find('.frame-root').forEach(function (n) { n.destroy(); });
    printLayer.find('.sticker-node').forEach(function (n) { n.destroy(); });
    printLayer.find('.motif-element').forEach(function (n) { n.destroy(); });
    printLayer.batchDraw();
  }

  function clearMotifBackground() {
    if (stickerState._motifBgNode) {
      stickerState._motifBgNode.destroy();
      stickerState._motifBgNode = null;
    }
    printLayer.find('.motif-bg').forEach(function (n) { n.destroy(); });
    printLayer.batchDraw();
  }

  function placeMotifPattern(tmpl, photoDataUrl) {
    var b = printLayer._printBounds;
    if (!b) return;

    var img = new Image();
    img.onload = function () {
      clearMotifBackground();
      clearStickerNodes();

      var imgAspect = img.width / img.height;
      var boundsAspect = b.w / b.h;
      var dw, dh, dx, dy;
      if (imgAspect > boundsAspect) {
        dh = b.h; dw = b.h * imgAspect;
        dx = b.x + (b.w - dw) / 2; dy = b.y;
      } else {
        dw = b.w; dh = b.w / imgAspect;
        dx = b.x; dy = b.y + (b.h - dh) / 2;
      }

      var bgNode = new Konva.Image({
        image: img,
        x: dx, y: dy,
        width: dw, height: dh,
        draggable: true,
        name: 'motif-bg'
      });
      bgNode.on('tap click', function () { selectNode(bgNode); });
      bgNode.on('transformend dragend', function () { printLayer.batchDraw(); });
      printLayer.add(bgNode);
      bgNode.moveToBottom();
      stickerState._motifBgNode = bgNode;

      var motifCanvas = document.createElement('canvas');
      tmpl.items.forEach(function (item) {
        var sz = b.w * item.size;
        var elemCanvas = document.createElement('canvas');
        elemCanvas.width = Math.ceil(sz * 2);
        elemCanvas.height = Math.ceil(sz * 2);
        var ectx = elemCanvas.getContext('2d');
        ectx.translate(elemCanvas.width / 2, elemCanvas.height / 2);

        if (tmpl.shape === 'star') {
          drawStarPath(ectx, 0, 0, sz / 2);
        } else if (tmpl.shape === 'flower') {
          drawFlowerPath(ectx, 0, 0, sz / 2);
        } else if (tmpl.shape === 'heart') {
          drawHeartPath(ectx, 0, 0, sz / 2);
        } else {
          ectx.beginPath();
          ectx.arc(0, 0, sz / 2, 0, Math.PI * 2);
        }

        if (tmpl.strokeOnly) {
          ectx.strokeStyle = tmpl.color;
          ectx.lineWidth = (tmpl.strokeWidth || 2) * (sz / 30);
          ectx.stroke();
        } else {
          ectx.fillStyle = tmpl.color;
          ectx.fill();
        }

        var elemImg = new Image();
        elemImg.onload = function () {
          var kNode = new Konva.Image({
            image: elemImg,
            x: b.x + b.w * item.xR - sz / 2,
            y: b.y + b.h * item.yR - sz / 2,
            width: sz,
            height: sz,
            rotation: item.rot || 0,
            draggable: true,
            name: 'motif-element'
          });
          kNode.on('tap click', function () { selectNode(kNode); });
          kNode.on('transformend dragend', function () { printLayer.batchDraw(); });
          printLayer.add(kNode);
          printLayer.batchDraw();
        };
        elemImg.src = elemCanvas.toDataURL();
      });

      transformer.nodes([]);
      printLayer.batchDraw();
    };
    img.src = photoDataUrl;
  }

  function placeStickersFromTemplate(tmpl, dataUrl) {
    var b = printLayer._printBounds;
    if (!b) return;

    var img = new Image();
    img.onload = function () {
      tmpl.slots.forEach(function (slot) {
        var stickerSize = b.w * slot.scale;
        var kImg = new Konva.Image({
          image: img,
          x: b.x + b.w * slot.xR - stickerSize / 2,
          y: b.y + b.h * slot.yR - stickerSize / 2,
          width: stickerSize,
          height: stickerSize * (img.height / img.width),
          rotation: slot.rot || 0,
          draggable: true,
          name: 'sticker-node'
        });
        kImg.on('tap click', function () { selectNode(kImg); });
        kImg.on('transformend dragend', function () { printLayer.batchDraw(); });
        printLayer.add(kImg);
      });

      transformer.nodes([]);
      printLayer.batchDraw();
      updateStickerList();
    };
    img.src = dataUrl;
  }

  /* ─── Crop Modal ─── */

  var _cropImage = null;
  var _cropCanvas = null;
  var _cropCtx = null;
  var _cropDragging = false;
  var _cropStart = {};

  function openCropModal(file) {
    var reader = new FileReader();
    reader.onload = function (e) {
      var img = new Image();
      img.onload = function () {
        _cropImage = img;
        showCropModal();
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  function showCropModal() {
    var modal = document.getElementById('cls-crop-modal');
    _cropCanvas = document.getElementById('cls-crop-canvas');
    _cropCtx = _cropCanvas.getContext('2d');

    modal.style.display = 'flex';

    requestAnimationFrame(function () {
      var container = document.getElementById('cls-crop-container');
      var cw = container.clientWidth;
      if (!cw) cw = 400;

      _cropCanvas.width = cw;
      _cropCanvas.height = cw;
      _cropCanvas.style.width = cw + 'px';
      _cropCanvas.style.height = cw + 'px';

      var scale = Math.min(cw / _cropImage.width, cw / _cropImage.height);
      var iw = _cropImage.width * scale;
      var ih = _cropImage.height * scale;
      var ix = (cw - iw) / 2;
      var iy = (cw - ih) / 2;

      stickerState.cropRect = {
        x: ix + iw * 0.1,
        y: iy + ih * 0.1,
        w: iw * 0.8,
        h: ih * 0.8
      };

      _cropCanvas._imgBounds = { ix: ix, iy: iy, iw: iw, ih: ih, scale: scale };
      drawCropOverlay();

      var handle = document.getElementById('cls-crop-handle');
      handle.style.display = 'block';
      updateCropHandle();
      initCropDrag(handle);
    });
  }

  function drawCropOverlay() {
    var cw = _cropCanvas.width, ch = _cropCanvas.height;
    _cropCtx.clearRect(0, 0, cw, ch);

    var b = _cropCanvas._imgBounds;
    _cropCtx.drawImage(_cropImage, b.ix, b.iy, b.iw, b.ih);

    _cropCtx.fillStyle = 'rgba(0,0,0,0.45)';
    _cropCtx.fillRect(0, 0, cw, ch);

    var r = stickerState.cropRect;
    _cropCtx.clearRect(r.x, r.y, r.w, r.h);
    _cropCtx.drawImage(
      _cropImage,
      (r.x - b.ix) / b.scale, (r.y - b.iy) / b.scale,
      r.w / b.scale, r.h / b.scale,
      r.x, r.y, r.w, r.h
    );
  }

  function updateCropHandle() {
    var handle = document.getElementById('cls-crop-handle');
    var r = stickerState.cropRect;
    handle.style.left = r.x + 'px';
    handle.style.top = r.y + 'px';
    handle.style.width = r.w + 'px';
    handle.style.height = r.h + 'px';
  }

  function initCropDrag(handle) {
    var startX, startY, startRect;

    function onStart(e) {
      e.preventDefault();
      _cropDragging = true;
      var pt = e.touches ? e.touches[0] : e;
      var rect = handle.parentElement.getBoundingClientRect();
      startX = pt.clientX - rect.left;
      startY = pt.clientY - rect.top;
      startRect = Object.assign({}, stickerState.cropRect);
    }

    function onMove(e) {
      if (!_cropDragging) return;
      e.preventDefault();
      var pt = e.touches ? e.touches[0] : e;
      var rect = handle.parentElement.getBoundingClientRect();
      var cx = pt.clientX - rect.left;
      var cy = pt.clientY - rect.top;
      var dx = cx - startX;
      var dy = cy - startY;

      var cw = _cropCanvas.width;
      stickerState.cropRect.x = Math.max(0, Math.min(cw - startRect.w, startRect.x + dx));
      stickerState.cropRect.y = Math.max(0, Math.min(cw - startRect.h, startRect.y + dy));
      updateCropHandle();
      drawCropOverlay();
    }

    function onEnd() { _cropDragging = false; }

    handle.addEventListener('mousedown', onStart);
    handle.addEventListener('touchstart', onStart, { passive: false });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('mouseup', onEnd);
    document.addEventListener('touchend', onEnd);
  }

  function getCroppedImageBlob() {
    var b = _cropCanvas._imgBounds;
    var r = stickerState.cropRect;
    var sx = (r.x - b.ix) / b.scale;
    var sy = (r.y - b.iy) / b.scale;
    var sw = r.w / b.scale;
    var sh = r.h / b.scale;

    var c = document.createElement('canvas');
    c.width = Math.round(sw);
    c.height = Math.round(sh);
    var ctx = c.getContext('2d');
    ctx.drawImage(_cropImage, sx, sy, sw, sh, 0, 0, c.width, c.height);

    return new Promise(function (resolve) {
      c.toBlob(function (blob) { resolve(blob); }, 'image/png');
    });
  }

  /* ─── AI Background Removal ─── */

  function removeBgAndModify(blob) {
    var overlay = document.getElementById('cls-ai-overlay');
    var statusEl = document.getElementById('cls-ai-status');
    overlay.style.display = 'flex';
    statusEl.textContent = 'Removing background…';

    function finishWithResult(dataUrl) {
      return fetch(dataUrl)
        .then(function (r) { return r.blob(); })
        .then(function (resultBlob) {
          stickerState.processedBlob = resultBlob;
          stickerState.processedDataUrl = dataUrl;
          overlay.style.display = 'none';
          document.getElementById('cls-crop-modal').style.display = 'none';
          openModifyModal();
        });
    }

    function fallback() {
      statusEl.textContent = 'Processing…';
      var url = URL.createObjectURL(blob);
      stickerState.processedBlob = blob;
      stickerState.processedDataUrl = url;
      overlay.style.display = 'none';
      document.getElementById('cls-crop-modal').style.display = 'none';
      openModifyModal();
    }

    removeBgViaProxy(blob)
      .then(function (resultDataUrl) {
        return finishWithResult(resultDataUrl);
      })
      .catch(function (err) {
        console.error('remove.bg failed, using original:', err);
        fallback();
      });
  }

  /* ─── Modify Sticker Modal ─── */

  var _modifyCanvas = null;
  var _modifyCtx = null;
  var _modifyImg = null;

  function openModifyModal() {
    var modal = document.getElementById('cls-modify-modal');
    _modifyCanvas = document.getElementById('cls-modify-canvas');
    _modifyCtx = _modifyCanvas.getContext('2d');

    modal.style.display = 'flex';

    var img = new Image();
    img.onload = function () {
      _modifyImg = img;
      renderModifyPreview();
    };
    img.src = stickerState.processedDataUrl;
  }

  function renderModifyPreview() {
    if (!_modifyImg) return;
    var pad = stickerState.outlineEnabled ? stickerState.outlineWidth * 2 : 0;
    var w = _modifyImg.width + pad * 2;
    var h = _modifyImg.height + pad * 2;

    _modifyCanvas.width = w;
    _modifyCanvas.height = h;
    _modifyCtx.clearRect(0, 0, w, h);

    if (stickerState.outlineEnabled && pad > 0) {
      _modifyCtx.save();
      var ow = stickerState.outlineWidth * 2;
      for (var angle = 0; angle < 360; angle += 15) {
        var rad = angle * Math.PI / 180;
        _modifyCtx.drawImage(
          _modifyImg,
          pad + Math.cos(rad) * ow,
          pad + Math.sin(rad) * ow,
          _modifyImg.width,
          _modifyImg.height
        );
      }
      _modifyCtx.globalCompositeOperation = 'source-in';
      _modifyCtx.fillStyle = '#ffffff';
      _modifyCtx.fillRect(0, 0, w, h);
      _modifyCtx.globalCompositeOperation = 'source-over';
      _modifyCtx.restore();
    }

    _modifyCtx.drawImage(_modifyImg, pad, pad);
  }

  function getModifiedStickerDataUrl() {
    return _modifyCanvas.toDataURL('image/png');
  }

  function finishSticker() {
    var dataUrl = getModifiedStickerDataUrl();
    stickerState.processedDataUrl = dataUrl;

    stickerState.stickers.push({
      dataUrl: dataUrl,
      timestamp: Date.now()
    });

    document.getElementById('cls-modify-modal').style.display = 'none';
    updateStickerList();

    var ftDone = FRAME_TEMPLATES.find(function (t) { return t.id === stickerState.selectedTemplate; });
    if (ftDone) {
      stickerState._framePhotoDataUrl = dataUrl;
      placeFrameTemplate(ftDone, dataUrl);
      return;
    }

    var tmpl = CUTOUT_TEMPLATES.find(function (t) { return t.id === stickerState.selectedTemplate; });
    if (tmpl) {
      applyStickerTemplate(tmpl);
    } else {
      var b = printLayer._printBounds;
      if (b) {
        var img = new Image();
        img.onload = function () {
          var sz = b.w * 0.4;
          var kImg = new Konva.Image({
            image: img,
            x: b.x + b.w / 2 - sz / 2,
            y: b.y + b.h / 2 - sz / 2,
            width: sz,
            height: sz * (img.height / img.width),
            draggable: true,
            name: 'sticker-node'
          });
          kImg.on('tap click', function () { selectNode(kImg); });
          kImg.on('transformend dragend', function () { printLayer.batchDraw(); });
          printLayer.add(kImg);
          selectNode(kImg);
          printLayer.batchDraw();
        };
        img.src = dataUrl;
      }
    }
  }

  function updateStickerList() {
    var list = document.getElementById('cls-sticker-list');
    if (!list) return;
    list.innerHTML = '';

    stickerState.stickers.forEach(function (s, idx) {
      var thumb = document.createElement('div');
      thumb.className = 'cls-sticker-thumb';
      var img = document.createElement('img');
      img.src = s.dataUrl;
      thumb.appendChild(img);

      var del = document.createElement('button');
      del.className = 'cls-sticker-thumb__delete';
      del.textContent = '×';
      del.addEventListener('click', function (e) {
        e.stopPropagation();
        stickerState.stickers.splice(idx, 1);
        updateStickerList();
      });
      thumb.appendChild(del);

      thumb.addEventListener('click', function () {
        stickerState.processedDataUrl = s.dataUrl;
        if (_activeTemplateTab === 'frames') {
          stickerState._framePhotoDataUrl = s.dataUrl;
          var imgF = new Image();
          imgF.onload = function () {
            stickerState._framePreviewImg = imgF;
            buildTemplateGrid();
            var fT = FRAME_TEMPLATES.find(function (t) { return t.id === stickerState.selectedTemplate; });
            if (fT) placeFrameTemplate(fT, s.dataUrl);
          };
          imgF.src = s.dataUrl;
          return;
        }
        if (_activeTemplateTab === 'motifs') {
          stickerState._motifPhotoDataUrl = s.dataUrl;
          var imgM = new Image();
          imgM.onload = function () {
            stickerState._motifPreviewImg = imgM;
            buildTemplateGrid();
            var mT = MOTIF_TEMPLATES.find(function (t) { return t.id === stickerState.selectedTemplate; });
            if (mT) placeMotifPattern(mT, s.dataUrl);
          };
          imgM.src = s.dataUrl;
          return;
        }
        var tmpl = CUTOUT_TEMPLATES.find(function (t) { return t.id === stickerState.selectedTemplate; });
        if (tmpl) applyStickerTemplate(tmpl);
      });

      list.appendChild(thumb);
    });
  }

  /* ─── Sticker Event Bindings ─── */

  function bindStickerStudio() {
    var templateTabs = document.querySelectorAll('.cls-template-tab');
    templateTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.disabled) return;
        templateTabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        _activeTemplateTab = tab.dataset.templateType || 'cutouts';
        stickerState.selectedTemplate = null;
        buildTemplateGrid();
      });
    });

    buildTemplateGrid();

    document.getElementById('cls-crop-close').addEventListener('click', function () {
      document.getElementById('cls-crop-modal').style.display = 'none';
    });

    document.getElementById('cls-crop-remove-bg').addEventListener('click', function () {
      getCroppedImageBlob().then(function (blob) {
        stickerState.croppedBlob = blob;
        removeBgAndModify(blob);
      });
    });

    document.getElementById('cls-crop-only').addEventListener('click', function () {
      getCroppedImageBlob().then(function (blob) {
        stickerState.croppedBlob = blob;
        var url = URL.createObjectURL(blob);
        stickerState.processedBlob = blob;
        stickerState.processedDataUrl = url;
        document.getElementById('cls-crop-modal').style.display = 'none';
        openModifyModal();
      });
    });

    document.getElementById('cls-modify-close').addEventListener('click', function () {
      document.getElementById('cls-modify-modal').style.display = 'none';
    });

    document.getElementById('cls-modify-back').addEventListener('click', function () {
      document.getElementById('cls-modify-modal').style.display = 'none';
      document.getElementById('cls-crop-modal').style.display = 'flex';
    });

    document.getElementById('cls-outline-toggle').addEventListener('change', function () {
      stickerState.outlineEnabled = this.checked;
      document.getElementById('cls-outline-sliders').style.display = this.checked ? '' : 'none';
      renderModifyPreview();
    });

    document.getElementById('cls-outline-smooth').addEventListener('input', function () {
      stickerState.outlineSmooth = parseInt(this.value, 10);
      renderModifyPreview();
    });

    document.getElementById('cls-outline-width').addEventListener('input', function () {
      stickerState.outlineWidth = parseInt(this.value, 10);
      renderModifyPreview();
    });

    document.getElementById('cls-add-sticker-btn').addEventListener('click', function () {
      finishSticker();
    });
  }

  /* ═══════════════════════════════════════════════════════
     LAYERS PANEL — view, reorder, delete
     ═══════════════════════════════════════════════════════ */

  var _layersPanelOpen = false;
  var _dragItem = null;
  var _dragPlaceholder = null;

  function toggleLayersPanel() {
    var panel = document.getElementById('cls-layers-panel');
    if (!panel) return;
    _layersPanelOpen = !_layersPanelOpen;
    panel.style.display = _layersPanelOpen ? 'flex' : 'none';
    if (_layersPanelOpen) {
      setTimeout(function () { refreshLayersList(); }, 50);
    }
  }

  function bindLayersPanel() {
    var closeBtn = document.getElementById('cls-layers-close');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      _layersPanelOpen = false;
      var panel = document.getElementById('cls-layers-panel');
      if (panel) panel.style.display = 'none';
    });
  }

  function getDesignNodes() {
    if (!printLayer) return [];
    var validNames = ['sticker-node', 'motif-element', 'motif-bg', 'userImage', 'userText', 'frame-root'];
    var children = printLayer.getChildren();
    var result = [];
    if (children && typeof children.toArray === 'function') {
      result = children.toArray();
    } else if (children && children.length) {
      for (var i = 0; i < children.length; i++) result.push(children[i]);
    } else if (Array.isArray(children)) {
      result = children;
    }
    return result.filter(function (n) {
      return n && typeof n.name === 'function' && validNames.indexOf(n.name()) >= 0;
    });
  }

  function refreshLayersList() {
    var list = document.getElementById('cls-layers-list');
    if (!list || !printLayer) return;
    list.innerHTML = '';

    var nodes = getDesignNodes();

    if (!nodes.length) {
      list.innerHTML = '<div class="cls-layers-empty">Nessun layer presente</div>';
      return;
    }

    var layerIdx = 0;
    nodes.slice().reverse().forEach(function (node, visualIdx) {
      var item = document.createElement('div');
      item.className = 'cls-layer-item';
      item.draggable = true;
      item.dataset.nodeIdx = String(nodes.length - 1 - visualIdx);
      var selected = transformer.nodes().indexOf(node) >= 0;
      if (selected) item.classList.add('cls-layer-item--selected');

      var grip = document.createElement('div');
      grip.className = 'cls-layer-item__grip';
      grip.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><circle cx="8" cy="6" r="1.5"/><circle cx="16" cy="6" r="1.5"/><circle cx="8" cy="12" r="1.5"/><circle cx="16" cy="12" r="1.5"/><circle cx="8" cy="18" r="1.5"/><circle cx="16" cy="18" r="1.5"/></svg>';
      item.appendChild(grip);

      var thumbWrap = document.createElement('div');
      thumbWrap.className = 'cls-layer-item__thumb';
      var thumbCanvas = document.createElement('canvas');
      thumbCanvas.width = 44; thumbCanvas.height = 44;
      renderLayerThumb(thumbCanvas, node);
      thumbWrap.appendChild(thumbCanvas);
      item.appendChild(thumbWrap);

      var info = document.createElement('div');
      info.className = 'cls-layer-item__info';
      var nameEl = document.createElement('div');
      nameEl.className = 'cls-layer-item__name';
      nameEl.textContent = getLayerLabel(node);
      info.appendChild(nameEl);
      item.appendChild(info);

      var actions = document.createElement('div');
      actions.className = 'cls-layer-item__actions';

      var upBtn = document.createElement('button');
      upBtn.className = 'cls-layer-item__move';
      upBtn.title = 'Move up';
      upBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="18 15 12 9 6 15"/></svg>';
      upBtn.disabled = visualIdx === 0;
      upBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        node.moveUp();
        printLayer.batchDraw();
        refreshLayersList();
      });
      actions.appendChild(upBtn);

      var downBtn = document.createElement('button');
      downBtn.className = 'cls-layer-item__move';
      downBtn.title = 'Move down';
      downBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>';
      downBtn.disabled = visualIdx === nodes.length - 1;
      downBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        node.moveDown();
        printLayer.batchDraw();
        refreshLayersList();
      });
      actions.appendChild(downBtn);

      var del = document.createElement('button');
      del.className = 'cls-layer-item__delete';
      del.title = 'Delete';
      del.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';
      del.addEventListener('click', function (e) {
        e.stopPropagation();
        if (transformer.nodes().indexOf(node) >= 0) transformer.nodes([]);
        node.destroy();
        printLayer.batchDraw();
        refreshLayersList();
      });
      actions.appendChild(del);

      item.appendChild(actions);

      item.addEventListener('click', function () {
        selectNode(node);
        refreshLayersList();
      });

      initDragReorder(item, list, nodes);

      list.appendChild(item);
    });
  }

  function initDragReorder(item, list, nodes) {
    item.addEventListener('dragstart', function (e) {
      _dragItem = item;
      item.classList.add('cls-layer-item--dragging');
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', item.dataset.nodeIdx);
    });

    item.addEventListener('dragend', function () {
      item.classList.remove('cls-layer-item--dragging');
      if (_dragPlaceholder && _dragPlaceholder.parentNode) {
        _dragPlaceholder.parentNode.removeChild(_dragPlaceholder);
      }
      _dragItem = null;
      _dragPlaceholder = null;
      list.querySelectorAll('.cls-layer-item--drag-over').forEach(function (el) {
        el.classList.remove('cls-layer-item--drag-over');
      });
    });

    item.addEventListener('dragover', function (e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      if (_dragItem && _dragItem !== item) {
        item.classList.add('cls-layer-item--drag-over');
      }
    });

    item.addEventListener('dragleave', function () {
      item.classList.remove('cls-layer-item--drag-over');
    });

    item.addEventListener('drop', function (e) {
      e.preventDefault();
      item.classList.remove('cls-layer-item--drag-over');
      if (!_dragItem || _dragItem === item) return;

      var fromIdx = parseInt(_dragItem.dataset.nodeIdx, 10);
      var toIdx = parseInt(item.dataset.nodeIdx, 10);
      if (isNaN(fromIdx) || isNaN(toIdx) || fromIdx === toIdx) return;

      var fromNode = nodes[fromIdx];
      if (!fromNode) return;

      if (toIdx > fromIdx) {
        fromNode.setZIndex(toIdx);
      } else {
        fromNode.setZIndex(toIdx);
      }

      printLayer.batchDraw();
      refreshLayersList();
    });
  }

  function renderLayerThumb(canvas, node) {
    var ctx = canvas.getContext('2d');
    var w = canvas.width, h = canvas.height;
    ctx.clearRect(0, 0, w, h);

    if (node instanceof Konva.Group && node.name() === 'frame-root') {
      ctx.fillStyle = '#ececec';
      ctx.fillRect(0, 0, w, h);
      ctx.strokeStyle = '#c62828';
      ctx.lineWidth = 2;
      ctx.beginPath();
      appendHeartPath2d(ctx, w / 2, h / 2 + 1, Math.min(w, h) * 0.22);
      ctx.stroke();
      return;
    }

    if (node instanceof Konva.Image && node.image()) {
      var img = node.image();
      var aspect = img.width / img.height;
      var dw, dh;
      if (aspect > 1) { dw = w; dh = w / aspect; } else { dh = h; dw = h * aspect; }
      ctx.drawImage(img, (w - dw) / 2, (h - dh) / 2, dw, dh);
    } else if (node instanceof Konva.Text) {
      ctx.fillStyle = node.fill() || '#000';
      ctx.font = 'bold 14px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var txt = node.text() || 'T';
      ctx.fillText(txt.substring(0, 4), w / 2, h / 2);
    } else if (node instanceof Konva.Shape) {
      ctx.fillStyle = '#ccc';
      ctx.beginPath();
      ctx.arc(w / 2, h / 2, 14, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  function getLayerLabel(node) {
    var nm = node.name();
    if (nm === 'sticker-node') return 'Sticker Layer';
    if (nm === 'motif-bg') return 'Photo Background';
    if (nm === 'motif-element') return 'Motif Element';
    if (nm === 'frame-root') return 'Frame';
    if (nm === 'frame-photo') return 'Foto nel frame';
    if (nm === 'userImage') return 'Image';
    if (nm === 'userText') return 'Text';
    return 'Layer';
  }


  /* ═══════════════════════════════════════════════════════
     BOOT
     ═══════════════════════════════════════════════════════ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); bindStickerStudio(); bindLayersPanel(); });
  } else {
    init();
    bindStickerStudio();
    bindLayersPanel();
  }

})();
